export default [
  {
    "Codes": "1",
    "Stadtteil": "Altstadt",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "3541",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "3601",
    "Bevölkerungsstruktur Frauen in %  2011": "50,1",
    "Bevölkerungsstruktur Frauen in %  2012": "49,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "1,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "4,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "5,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "1848",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "1621",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "479",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "726",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "1214",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "1254",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "34,3",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "34,8",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "43,4",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "43,4",
    "Bevölkerungsstruktur Jugendquotient  2011": "16,2",
    "Bevölkerungsstruktur Jugendquotient  2012": "15,8",
    "Bevölkerungsstruktur Altenquotient  2011": "23,9",
    "Bevölkerungsstruktur Altenquotient  2012": "23,7",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "150",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "149",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "46,0",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "47,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "88",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "22",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "29",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "90",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "33",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "37",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "136",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "139",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "42,6",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "41,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "58",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "19",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "35",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "81",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "43",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "39",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "72",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "74",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "44,4",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "48,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "19",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "16",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "30",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "32",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "23",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "26",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "634",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "647",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "54,9",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "54,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "265",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "257",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "93",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "110",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "276",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "280",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "1945",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "1981",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "46,4",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "46,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "942",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "894",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "271",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "326",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "732",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "761",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "604",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "611",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "60,1",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "58,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "476",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "413",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "21",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "87",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "107",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "111",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,0",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "51,0",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "470",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "469",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,1",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "49,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "51,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "48,3",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "112",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "184",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "49,1",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "51,1",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "851",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "836",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "65",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "71",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "64",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "70",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "230",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "272",
    "Bevölkerungsstruktur Staatenlose  2011": "4",
    "Bevölkerungsstruktur Staatenlose  2012": "5",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "84",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "86",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "19",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "20",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "36",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "38",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "109",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "111",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "95",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "101",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "24",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "26",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "76",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "75",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "13",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "9",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "84",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "72",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "37",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "34",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "131",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "124",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "7",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "12",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "2",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "12",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "37",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "48",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "17",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "18",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "32",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "37",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "46",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "71",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "18",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "23",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "13",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "17",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "30",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "28",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "48",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "85",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "928",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "971",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "394",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "407",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "513",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "536",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "21",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "28",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "1461",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "1457",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "137",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "131",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "785",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "788",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "539",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "538",
    "": ""
  },
  {
    "Codes": "2",
    "Stadtteil": "Innenstadt",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "6232",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "6334",
    "Bevölkerungsstruktur Frauen in %  2011": "46,3",
    "Bevölkerungsstruktur Frauen in %  2012": "46,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "-0,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "0,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "1,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "4,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "2791",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "2460",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "746",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "1135",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "2695",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2739",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "43,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "43,2",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,8",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "41,6",
    "Bevölkerungsstruktur Jugendquotient  2011": "14,4",
    "Bevölkerungsstruktur Jugendquotient  2012": "13,5",
    "Bevölkerungsstruktur Altenquotient  2011": "19,8",
    "Bevölkerungsstruktur Altenquotient  2012": "19,3",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "244",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "223",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "47,5",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "47,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "110",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "33",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "55",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "124",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "79",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "66",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "206",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "225",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,5",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "52,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "64",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "22",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "60",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "116",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "82",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "87",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "117",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "119",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "47,9",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "43,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "33",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "21",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "28",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "43",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "56",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "55",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1428",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1415",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "49,4",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "663",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "649",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "154",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "199",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "611",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "567",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "3318",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "3433",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "40,7",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "41,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "1273",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "1194",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "407",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "512",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1638",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1727",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "919",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "919",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "60,9",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "60,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "648",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "541",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "42",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "141",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "229",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "237",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "46,2",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "46,9",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1022",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1077",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "40,8",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "42,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "43,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "47,7",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "186",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "333",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "44,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "50,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1915",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1936",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "94",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "106",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "161",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "184",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "512",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "505",
    "Bevölkerungsstruktur Staatenlose  2011": "13",
    "Bevölkerungsstruktur Staatenlose  2012": "8",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "98",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "109",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "64",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "60",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "60",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "81",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "168",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "171",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "160",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "141",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "26",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "30",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "116",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "138",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "124",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "149",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "208",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "206",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "83",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "86",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "349",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "324",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "18",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "26",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "7",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "15",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "46",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "66",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "20",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "24",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "65",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "78",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "61",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "110",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "31",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "53",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "28",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "33",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "40",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "45",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "85",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "115",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2342",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2405",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1064",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1075",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1207",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1268",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "71",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "62",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "2000",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "2006",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "178",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "176",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "1066",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "1073",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "756",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "757",
    "": ""
  },
  {
    "Codes": "3",
    "Stadtteil": "Bahnhofsviertel",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "2662",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "3117",
    "Bevölkerungsstruktur Frauen in %  2011": "39,3",
    "Bevölkerungsstruktur Frauen in %  2012": "37,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "1,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "21,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "15,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "25,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "1079",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "1112",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "210",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "375",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "1373",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "1630",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "51,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "52,3",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "38,6",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "37,5",
    "Bevölkerungsstruktur Jugendquotient  2011": "10,7",
    "Bevölkerungsstruktur Jugendquotient  2012": "10,8",
    "Bevölkerungsstruktur Altenquotient  2011": "8,7",
    "Bevölkerungsstruktur Altenquotient  2012": "7,9",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "79",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "115",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "43,0",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "51,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "37",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "26",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "10",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "48",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "32",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "41",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "64",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "81",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,4",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "45,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "17",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "10",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "20",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "34",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "27",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "37",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "43",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "45",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "51,2",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "37,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "12",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "5",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "10",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "12",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "21",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "28",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "695",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "865",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "46,3",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "42,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "277",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "328",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "62",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "94",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "356",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "443",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "1586",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "1804",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "35,2",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "33,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "665",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "673",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "101",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "171",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "820",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "960",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "195",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "207",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "40,5",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "39,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "71",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "70",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "7",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "16",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "117",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "121",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "41,6",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "38,2",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "718",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "861",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "42,5",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "40,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "40,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "39,2",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "65",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "99",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "44,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "41,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "956",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1128",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "62",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "93",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "58",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "71",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "286",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "329",
    "Bevölkerungsstruktur Staatenlose  2011": "11",
    "Bevölkerungsstruktur Staatenlose  2012": "9",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "92",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "98",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "8",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "13",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "134",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "117",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "48",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "51",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "29",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "33",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "24",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "32",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "94",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "109",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "120",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "138",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "48",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "60",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "37",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "67",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "126",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "124",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "4",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "3",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "1",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "10",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "10",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "11",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "9",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "12",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "15",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "16",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "14",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "17",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "8",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "8",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "8",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "4",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "13",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "11",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "15",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "26",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1368",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "1692",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "574",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "719",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "784",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "958",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "10",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "15",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "601",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "611",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "71",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "69",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "370",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "375",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "160",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "167",
    "": ""
  },
  {
    "Codes": "4",
    "Stadtteil": "Westend-Süd",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "16733",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "17076",
    "Bevölkerungsstruktur Frauen in %  2011": "50,8",
    "Bevölkerungsstruktur Frauen in %  2012": "51,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "5,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "6,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "4,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "5,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "11308",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "10066",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1590",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "2957",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3835",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "4053",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "22,9",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "23,7",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "40,8",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "40,7",
    "Bevölkerungsstruktur Jugendquotient  2011": "21,6",
    "Bevölkerungsstruktur Jugendquotient  2012": "22,3",
    "Bevölkerungsstruktur Altenquotient  2011": "21,8",
    "Bevölkerungsstruktur Altenquotient  2012": "21,9",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1123",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1197",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,2",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "866",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "563",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "116",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "473",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "141",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "161",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "897",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "934",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,0",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "574",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "403",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "151",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "374",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "172",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "157",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "321",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "322",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "53,6",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "50,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "175",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "132",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "67",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "114",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "79",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "76",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2619",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2597",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,0",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "53,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1576",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1479",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "289",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "335",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "754",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "783",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "9233",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "9435",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "48,9",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "48,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "5988",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "5713",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "864",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1183",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2381",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2539",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2540",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2591",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,9",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "57,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2129",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1776",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "103",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "478",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "308",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "337",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,3",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "51,9",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "2162",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2276",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,9",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "49,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "52,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "52,8",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "660",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1354",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "52,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "54,3",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2757",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2911",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "71",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "71",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "362",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "368",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "640",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "698",
    "Bevölkerungsstruktur Staatenlose  2011": "5",
    "Bevölkerungsstruktur Staatenlose  2012": "5",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "114",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "119",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "21",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "22",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "167",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "161",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "355",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "375",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "92",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "100",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "13",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "12",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "206",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "237",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "72",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "87",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "99",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "103",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "168",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "190",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "142",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "149",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "10",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "27",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "6",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "16",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "112",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "150",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "61",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "104",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "20",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "26",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "134",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "308",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "100",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "170",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "37",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "24",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "129",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "168",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "76",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "154",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "5279",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "5304",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1920",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1918",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "3229",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "3256",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "130",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "130",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "5561",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "5543",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "458",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "419",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "2887",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "2883",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2216",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2241",
    "": ""
  },
  {
    "Codes": "5",
    "Stadtteil": "Westend-Nord",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "9012",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "9083",
    "Bevölkerungsstruktur Frauen in %  2011": "51,7",
    "Bevölkerungsstruktur Frauen in %  2012": "52,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "20,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "20,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "15,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "12,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "5525",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "4778",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1208",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "1993",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "2279",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2312",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "25,3",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "25,5",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "40,2",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "40,0",
    "Bevölkerungsstruktur Jugendquotient  2011": "25,5",
    "Bevölkerungsstruktur Jugendquotient  2012": "26,0",
    "Bevölkerungsstruktur Altenquotient  2011": "22,6",
    "Bevölkerungsstruktur Altenquotient  2012": "22,4",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "618",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "626",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "50,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "52,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "424",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "224",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "93",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "293",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "101",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "109",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "561",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "583",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,5",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "46,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "298",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "179",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "152",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "307",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "111",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "97",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "247",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "239",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "52,6",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "52,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "99",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "52",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "58",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "104",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "90",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "83",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1566",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1604",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,6",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "55,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "859",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "821",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "236",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "287",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "471",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "496",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "4647",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "4661",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "49,9",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "2704",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "2538",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "614",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "779",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1329",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1344",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "1373",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "1370",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "58,3",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "57,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1141",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "964",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "55",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "223",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "177",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "183",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "53,0",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "53,7",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "906",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "933",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "52,1",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "50,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "52,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "51,9",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "334",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "636",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "50,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "52,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1566",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1550",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "125",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "122",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "151",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "170",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "433",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "467",
    "Bevölkerungsstruktur Staatenlose  2011": "4",
    "Bevölkerungsstruktur Staatenlose  2012": "3",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "108",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "103",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "64",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "57",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "73",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "74",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "193",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "188",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "99",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "94",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "55",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "58",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "83",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "84",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "42",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "42",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "110",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "92",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "79",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "91",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "240",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "236",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "40",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "64",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "16",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "38",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "90",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "106",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "49",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "78",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "102",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "147",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "93",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "163",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "57",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "86",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "38",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "28",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "93",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "100",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "95",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "163",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2456",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2381",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "965",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1001",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1389",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1286",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "102",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "94",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "3304",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "3298",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "357",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "362",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "1800",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "1787",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "1147",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "1149",
    "": ""
  },
  {
    "Codes": "6",
    "Stadtteil": "Nordend-West",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "27715",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "28262",
    "Bevölkerungsstruktur Frauen in %  2011": "51,7",
    "Bevölkerungsstruktur Frauen in %  2012": "51,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "4,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "7,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "6,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "20063",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "18399",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2293",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4316",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "5359",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "5547",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "19,3",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "19,6",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,4",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "41,2",
    "Bevölkerungsstruktur Jugendquotient  2011": "19,3",
    "Bevölkerungsstruktur Jugendquotient  2012": "19,7",
    "Bevölkerungsstruktur Altenquotient  2011": "20,1",
    "Bevölkerungsstruktur Altenquotient  2012": "20,2",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1662",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1697",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "1380",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "908",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "153",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "662",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "129",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "127",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1369",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1466",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,7",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "48,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "1031",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "781",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "192",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "550",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "146",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "135",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "495",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "510",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "43,2",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "46,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "349",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "291",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "70",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "140",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "76",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "79",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "4265",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "4389",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "54,3",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "54,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "2760",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "2698",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "475",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "584",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1030",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1107",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "15934",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "16113",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "49,9",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "11220",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "10771",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1273",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1825",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "3441",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "3517",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3990",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "4087",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "59,5",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "59,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "3323",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2950",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "130",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "555",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "537",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "582",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "50,1",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "49,8",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "2680",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2764",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,2",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "48,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "53,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "52,1",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "834",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1808",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "55,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "53,1",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "4208",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "4308",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "176",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "166",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "347",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "383",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "615",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "676",
    "Bevölkerungsstruktur Staatenlose  2011": "13",
    "Bevölkerungsstruktur Staatenlose  2012": "14",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "121",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "121",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "132",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "127",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "227",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "227",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "491",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "504",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "462",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "492",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "45",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "41",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "370",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "338",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "159",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "199",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "248",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "243",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "267",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "292",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "393",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "381",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "22",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "40",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "26",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "51",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "150",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "195",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "116",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "198",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "78",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "87",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "196",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "415",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "122",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "195",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "99",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "83",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "152",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "195",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "163",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "291",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "7126",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "7285",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "2708",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "2851",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "4234",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "4249",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "184",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "185",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "11308",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "11380",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1084",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1079",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "6662",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "6665",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "3562",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "3636",
    "": ""
  },
  {
    "Codes": "7",
    "Stadtteil": "Nordend-Ost",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "25111",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "25410",
    "Bevölkerungsstruktur Frauen in %  2011": "52,0",
    "Bevölkerungsstruktur Frauen in %  2012": "51,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "2,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "3,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "2,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "4,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "17427",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "16089",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2418",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3962",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "5266",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "5359",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "21,0",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "21,1",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "40,7",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "40,7",
    "Bevölkerungsstruktur Jugendquotient  2011": "18,0",
    "Bevölkerungsstruktur Jugendquotient  2012": "18,4",
    "Bevölkerungsstruktur Altenquotient  2011": "16,7",
    "Bevölkerungsstruktur Altenquotient  2012": "16,6",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1386",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1434",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,9",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "1144",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "746",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "155",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "594",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "87",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "94",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1218",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1246",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,3",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "841",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "597",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "227",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "520",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "150",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "129",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "497",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "502",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "50,5",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "49,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "297",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "234",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "91",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "167",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "109",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "101",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "4054",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "4000",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "56,3",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "56,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "2607",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "2381",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "484",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "582",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "963",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1037",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "14835",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "15097",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,1",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "10196",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "10082",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1300",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1664",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "3339",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "3351",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3121",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3131",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,7",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "57,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2342",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2049",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "161",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "435",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "618",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "647",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "50,9",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "51,1",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "2252",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2352",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,8",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "49,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "53,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "52,2",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "722",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1404",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "55,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "54,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "4142",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "4209",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "189",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "182",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "317",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "321",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "608",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "637",
    "Bevölkerungsstruktur Staatenlose  2011": "10",
    "Bevölkerungsstruktur Staatenlose  2012": "10",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "114",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "112",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "177",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "182",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "177",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "180",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "471",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "479",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "527",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "521",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "77",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "73",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "264",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "286",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "114",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "128",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "290",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "282",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "248",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "284",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "658",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "628",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "48",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "72",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "23",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "51",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "130",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "171",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "114",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "180",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "121",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "151",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "200",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "344",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "101",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "147",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "84",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "75",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "165",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "192",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "224",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "364",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "6204",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "6239",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "2469",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "2495",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "3637",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "3640",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "98",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "104",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "10596",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "10605",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1081",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1051",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "6654",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "6698",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2861",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2856",
    "": ""
  },
  {
    "Codes": "8",
    "Stadtteil": "Ostend",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "26140",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "26540",
    "Bevölkerungsstruktur Frauen in %  2011": "51,6",
    "Bevölkerungsstruktur Frauen in %  2012": "51,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "0,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "1,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "4,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "15681",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "14166",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "3212",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4983",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "7247",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "7391",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "27,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "27,8",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "42,5",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,5",
    "Bevölkerungsstruktur Jugendquotient  2011": "18,2",
    "Bevölkerungsstruktur Jugendquotient  2012": "18,4",
    "Bevölkerungsstruktur Altenquotient  2011": "23,3",
    "Bevölkerungsstruktur Altenquotient  2012": "23,3",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1294",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1351",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "906",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "534",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "262",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "678",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "126",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "139",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1168",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1170",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,5",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "655",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "379",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "319",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "616",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "194",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "175",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "561",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "574",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "45,8",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "46,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "255",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "168",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "128",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "232",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "178",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "174",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "4381",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "4401",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "53,8",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "54,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "2328",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "2245",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "612",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "693",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1441",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1463",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "14433",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "14688",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "48,7",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "48,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "8298",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "8031",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1661",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "2096",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "4474",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "4561",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "4303",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "4356",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "61,2",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "60,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "3239",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2809",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "230",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "668",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "834",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "879",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "49,2",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "48,6",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "2536",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2677",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,5",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "47,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "50,8",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "802",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1513",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "52,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "53,9",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "5730",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "5877",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "360",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "358",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "308",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "311",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "823",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "817",
    "Bevölkerungsstruktur Staatenlose  2011": "26",
    "Bevölkerungsstruktur Staatenlose  2012": "28",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "116",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "118",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "250",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "253",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "221",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "220",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "451",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "458",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "734",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "764",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "172",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "155",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "372",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "404",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "260",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "328",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "628",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "613",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "211",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "236",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "1159",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "1146",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "69",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "89",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "56",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "124",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "164",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "191",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "92",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "133",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "242",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "290",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "252",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "460",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "119",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "200",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "129",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "115",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "286",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "298",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "347",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "584",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "6592",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "6630",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "2659",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "2650",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "3738",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "3769",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "195",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "211",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "11217",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "11303",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1130",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1147",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "6279",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "6320",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "3808",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "3836",
    "": ""
  },
  {
    "Codes": "9",
    "Stadtteil": "Bornheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "26130",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "26105",
    "Bevölkerungsstruktur Frauen in %  2011": "53,1",
    "Bevölkerungsstruktur Frauen in %  2012": "53,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "6,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "6,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "6,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "4,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "17158",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "15413",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "3041",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4758",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "5931",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "5934",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "22,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "22,7",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "43,0",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "43,2",
    "Bevölkerungsstruktur Jugendquotient  2011": "20,9",
    "Bevölkerungsstruktur Jugendquotient  2012": "20,7",
    "Bevölkerungsstruktur Altenquotient  2011": "26,5",
    "Bevölkerungsstruktur Altenquotient  2012": "26,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1452",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1421",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "51,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "1060",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "541",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "277",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "776",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "115",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "104",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1344",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1363",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "47,4",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "834",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "547",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "324",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "657",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "186",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "159",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "582",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "581",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "46,7",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "49,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "318",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "246",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "121",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "189",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "143",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "146",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "3850",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "3758",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "54,7",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "55,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "2240",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "2129",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "535",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "607",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1075",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1022",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "14205",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "14243",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "51,6",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "51,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "9062",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "8682",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1571",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1948",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "3572",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "3613",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "4697",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "4739",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "60,0",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "59,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "3644",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "3268",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "213",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "581",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "840",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "890",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,8",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "52,0",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "2143",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2189",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "50,0",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "50,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "52,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "52,0",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "691",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1325",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "53,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "54,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "4781",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "4775",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "297",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "285",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "238",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "247",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "594",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "609",
    "Bevölkerungsstruktur Staatenlose  2011": "21",
    "Bevölkerungsstruktur Staatenlose  2012": "18",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "119",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "117",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "300",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "284",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "136",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "146",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "573",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "582",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "584",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "580",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "118",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "111",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "357",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "347",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "75",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "89",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "386",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "377",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "165",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "186",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "881",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "860",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "42",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "52",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "48",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "122",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "160",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "196",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "115",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "144",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "215",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "272",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "220",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "429",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "58",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "89",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "130",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "114",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "237",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "274",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "325",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "579",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "4972",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "4927",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1924",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1877",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "2806",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "2811",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "242",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "239",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "12637",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "12665",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1324",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1312",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "7200",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "7212",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "4113",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "4141",
    "": ""
  },
  {
    "Codes": "10",
    "Stadtteil": "Gutleutviertel",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "5946",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "5952",
    "Bevölkerungsstruktur Frauen in %  2011": "45,4",
    "Bevölkerungsstruktur Frauen in %  2012": "44,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "10,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "11,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "9,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "3,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "2950",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "2626",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "737",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "1090",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "2259",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2236",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "38,0",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "37,6",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "40,9",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "41,1",
    "Bevölkerungsstruktur Jugendquotient  2011": "16,7",
    "Bevölkerungsstruktur Jugendquotient  2012": "16,8",
    "Bevölkerungsstruktur Altenquotient  2011": "20,2",
    "Bevölkerungsstruktur Altenquotient  2012": "20,4",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "288",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "269",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,0",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "162",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "71",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "87",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "166",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "39",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "32",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "237",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "240",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "53,2",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "52,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "77",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "36",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "83",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "142",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "77",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "62",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "128",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "151",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "45,3",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "43,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "25",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "24",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "26",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "35",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "77",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "92",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1199",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1205",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,0",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "49,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "587",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "570",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "168",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "193",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "444",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "442",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "3217",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "3201",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "40,4",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "40,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "1542",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "1459",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "332",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "430",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1343",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1312",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "877",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "886",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "54,2",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "53,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "557",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "466",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "41",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "124",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "279",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "296",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "44,5",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "43,4",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "899",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "881",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "44,4",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "44,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "47,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,2",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "162",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "289",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "56,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "58,8",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1547",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1486",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "249",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "238",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "47",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "55",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "408",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "448",
    "Bevölkerungsstruktur Staatenlose  2011": "8",
    "Bevölkerungsstruktur Staatenlose  2012": "9",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "98",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "93",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "44",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "47",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "209",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "208",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "128",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "123",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "177",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "171",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "137",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "142",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "158",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "141",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "40",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "48",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "94",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "83",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "46",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "35",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "229",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "210",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "52",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "63",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "18",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "31",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "27",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "35",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "20",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "31",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "102",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "124",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "43",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "89",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "25",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "27",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "30",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "25",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "46",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "40",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "53",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "70",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2081",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "1983",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "813",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "858",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1162",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1034",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "106",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "91",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "1851",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "1839",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "208",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "198",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "976",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "954",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "667",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "687",
    "": ""
  },
  {
    "Codes": "11",
    "Stadtteil": "Gallus",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "27318",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "28165",
    "Bevölkerungsstruktur Frauen in %  2011": "46,5",
    "Bevölkerungsstruktur Frauen in %  2012": "46,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "6,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "11,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "11,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "14,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "11727",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "10095",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "4134",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "6307",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "11457",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "11763",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "41,9",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "41,8",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "38,7",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "38,6",
    "Bevölkerungsstruktur Jugendquotient  2011": "22,6",
    "Bevölkerungsstruktur Jugendquotient  2012": "22,6",
    "Bevölkerungsstruktur Altenquotient  2011": "16,2",
    "Bevölkerungsstruktur Altenquotient  2012": "16,0",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1627",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1730",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,0",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "46,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "827",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "227",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "505",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "1182",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "295",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "321",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1586",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1628",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,7",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "577",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "189",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "536",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "983",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "473",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "456",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "795",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "798",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "46,8",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "47,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "212",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "108",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "183",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "312",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "400",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "378",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "5750",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "5737",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "49,5",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "2502",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "2421",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "874",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "997",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "2374",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "2319",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "14373",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "15024",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "43,4",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "43,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "5594",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "5370",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1880",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "2446",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "6899",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "7208",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3187",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3248",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "53,5",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "53,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2015",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1780",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "156",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "387",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "1016",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "1081",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "46,1",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "46,0",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "4085",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "4333",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "41,0",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "41,1",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "47,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "46,5",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "702",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1089",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "50,1",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "48,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "8667",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "8859",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "992",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "1034",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "262",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "291",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "1469",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "1512",
    "Bevölkerungsstruktur Staatenlose  2011": "67",
    "Bevölkerungsstruktur Staatenlose  2012": "67",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "133",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "138",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "483",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "482",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "687",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "665",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "571",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "552",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "797",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "761",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "443",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "442",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "893",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "923",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "358",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "442",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "932",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "964",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "254",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "290",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "1994",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "1913",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "144",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "188",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "131",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "301",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "101",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "120",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "105",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "111",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "614",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "888",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "251",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "376",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "102",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "152",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "201",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "213",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "270",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "267",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "576",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "939",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "8082",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "8469",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "3486",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "3532",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "4472",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "4796",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "124",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "141",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "10017",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "10041",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1375",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1338",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "5796",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "5826",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2846",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2877",
    "": ""
  },
  {
    "Codes": "12",
    "Stadtteil": "Bockenheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "34581",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "35789",
    "Bevölkerungsstruktur Frauen in %  2011": "50,7",
    "Bevölkerungsstruktur Frauen in %  2012": "50,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "18,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "20,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "12,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "14,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "20669",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "18699",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "4365",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "6920",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "9547",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "10170",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "27,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "28,4",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "39,1",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "38,9",
    "Bevölkerungsstruktur Jugendquotient  2011": "19,7",
    "Bevölkerungsstruktur Jugendquotient  2012": "20,0",
    "Bevölkerungsstruktur Altenquotient  2011": "16,3",
    "Bevölkerungsstruktur Altenquotient  2012": "16,0",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "2065",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "2165",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "1388",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "742",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "438",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "1168",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "239",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "255",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1719",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1825",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,3",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "48,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "941",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "528",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "494",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "999",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "284",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "298",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "761",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "747",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "48,1",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "47,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "374",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "278",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "179",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "266",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "208",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "203",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "7204",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "7489",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "55,5",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "54,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "3936",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "3885",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "886",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "1058",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "2382",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "2546",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "18684",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "19357",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "47,7",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "47,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "10834",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "10451",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "2196",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "2858",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "5654",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "6048",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "4148",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "4206",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "58,1",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "57,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "3196",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2815",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "172",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "571",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "780",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "820",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "50,7",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "50,1",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "3907",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "4304",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,9",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "48,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "49,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "50,0",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "1181",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "2052",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "52,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "52,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "7029",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "7464",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "608",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "605",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "462",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "487",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "1415",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "1586",
    "Bevölkerungsstruktur Staatenlose  2011": "33",
    "Bevölkerungsstruktur Staatenlose  2012": "28",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "134",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "137",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "172",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "165",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "539",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "566",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "711",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "729",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "572",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "568",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "196",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "193",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "540",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "570",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "269",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "333",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "330",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "321",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "257",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "321",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "1557",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "1542",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "67",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "105",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "83",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "181",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "267",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "331",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "144",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "203",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "301",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "399",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "381",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "639",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "134",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "161",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "143",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "143",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "316",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "311",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "532",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "868",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "10801",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "11362",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "4948",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "5210",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "5659",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "5952",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "194",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "200",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "12388",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "12438",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1416",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1421",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "7297",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "7302",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "3675",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "3715",
    "": ""
  },
  {
    "Codes": "13",
    "Stadtteil": "Sachsenhausen-Nord",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "29534",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "29789",
    "Bevölkerungsstruktur Frauen in %  2011": "51,3",
    "Bevölkerungsstruktur Frauen in %  2012": "51,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "11,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "9,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "5,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "6,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "19646",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "17787",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "3134",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "5248",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "6754",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "6754",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "22,9",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "22,7",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "40,5",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "40,6",
    "Bevölkerungsstruktur Jugendquotient  2011": "21,8",
    "Bevölkerungsstruktur Jugendquotient  2012": "22,2",
    "Bevölkerungsstruktur Altenquotient  2011": "19,7",
    "Bevölkerungsstruktur Altenquotient  2012": "20,3",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1875",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1836",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,0",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "1436",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "839",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "260",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "838",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "179",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "159",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1668",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1717",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,6",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "1115",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "727",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "318",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "779",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "235",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "211",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "676",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "699",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "51,9",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "391",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "310",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "141",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "246",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "144",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "143",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "4720",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "4788",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "53,4",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "53,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "2788",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "2745",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "592",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "694",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1340",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1349",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "16480",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "16513",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "49,5",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "10507",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "10064",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1685",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "2173",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "4288",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "4276",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "4115",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "4236",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,8",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "57,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "3409",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "3102",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "138",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "518",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "568",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "616",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "50,3",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "50,1",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "3024",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "3044",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "47,9",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "47,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "53,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "52,9",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "879",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1723",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "56,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "55,3",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "5069",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "5044",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "258",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "255",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "470",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "483",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "933",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "944",
    "Bevölkerungsstruktur Staatenlose  2011": "24",
    "Bevölkerungsstruktur Staatenlose  2012": "28",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "120",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "119",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "199",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "191",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "200",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "209",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "560",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "551",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "466",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "458",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "111",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "102",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "313",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "340",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "228",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "251",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "410",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "395",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "252",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "284",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "630",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "607",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "83",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "138",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "45",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "122",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "196",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "236",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "125",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "200",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "179",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "252",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "231",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "421",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "118",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "169",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "122",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "126",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "225",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "235",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "279",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "446",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "7602",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "7596",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "2896",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "3012",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "4512",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "4369",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "194",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "215",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "11491",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "11546",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1218",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1186",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "6639",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "6628",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "3634",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "3732",
    "": ""
  },
  {
    "Codes": "14",
    "Stadtteil": "Sachsenhausen-Süd",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "25509",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "25786",
    "Bevölkerungsstruktur Frauen in %  2011": "51,9",
    "Bevölkerungsstruktur Frauen in %  2012": "51,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "3,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "5,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "4,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "17938",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "15905",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2441",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4474",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "5130",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "5407",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "20,1",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "21,0",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "44,8",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "44,7",
    "Bevölkerungsstruktur Jugendquotient  2011": "21,9",
    "Bevölkerungsstruktur Jugendquotient  2012": "22,8",
    "Bevölkerungsstruktur Altenquotient  2011": "34,4",
    "Bevölkerungsstruktur Altenquotient  2012": "34,6",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1329",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1397",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "46,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "46,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "1018",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "607",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "175",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "631",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "136",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "159",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1341",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1349",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,3",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "966",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "627",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "224",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "582",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "151",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "140",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "604",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "657",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "48,2",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "47,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "395",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "326",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "95",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "213",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "114",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "118",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "3577",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "3591",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,2",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "53,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "2065",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1947",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "487",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "565",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1025",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1079",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "13047",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "13122",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,3",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "50,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "8569",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "8057",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1301",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1709",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "3177",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "3356",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "5611",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "5670",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,8",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "57,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "4925",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "4341",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "159",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "774",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "527",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "555",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "50,8",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "50,7",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "2187",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2377",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "49,2",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "48,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "52,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "52,5",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "782",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1716",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "55,1",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "54,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "3769",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "3965",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "187",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "178",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "327",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "348",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "827",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "897",
    "Bevölkerungsstruktur Staatenlose  2011": "20",
    "Bevölkerungsstruktur Staatenlose  2012": "19",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "125",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "124",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "160",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "144",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "131",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "136",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "389",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "434",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "410",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "406",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "51",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "42",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "347",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "408",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "127",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "147",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "250",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "238",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "159",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "181",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "474",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "465",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "66",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "99",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "17",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "54",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "200",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "253",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "88",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "150",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "101",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "163",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "212",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "537",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "125",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "221",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "81",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "77",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "184",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "205",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "186",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "342",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "5716",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "5822",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "2.021",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "2066",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "3.391",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "3471",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "304",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "285",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "11868",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "11842",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1.132",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1099",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "5.851",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "5793",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "4.885",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "4950",
    "": ""
  },
  {
    "Codes": "16",
    "Stadtteil": "Oberrad",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "12392",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "12561",
    "Bevölkerungsstruktur Frauen in %  2011": "50,9",
    "Bevölkerungsstruktur Frauen in %  2012": "50,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "9,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "10,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "4,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "4,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "7458",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "6517",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1707",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "2630",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3227",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "3414",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "26,0",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "27,2",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "42,8",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,8",
    "Bevölkerungsstruktur Jugendquotient  2011": "25,1",
    "Bevölkerungsstruktur Jugendquotient  2012": "25,6",
    "Bevölkerungsstruktur Altenquotient  2011": "28,0",
    "Bevölkerungsstruktur Altenquotient  2012": "27,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "659",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "655",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,4",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "431",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "171",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "144",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "380",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "84",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "104",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "809",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "838",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,1",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "437",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "235",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "229",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "457",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "143",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "146",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "382",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "410",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "50,8",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "51,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "184",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "146",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "92",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "138",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "106",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "126",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1797",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1843",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "53,8",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "52,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "929",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "921",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "307",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "334",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "561",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "588",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "6479",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "6539",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "48,4",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "48,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3586",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "3381",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "855",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1026",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2038",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2132",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2266",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2276",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,5",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "56,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1891",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1663",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "80",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "295",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "295",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "318",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "49,7",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "48,9",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1168",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1279",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "49,6",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "48,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "395",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "740",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "49,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "51,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2481",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2595",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "199",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "211",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "86",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "82",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "423",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "487",
    "Bevölkerungsstruktur Staatenlose  2011": "38",
    "Bevölkerungsstruktur Staatenlose  2012": "39",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "100",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "103",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "90",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "92",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "72",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "75",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "224",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "232",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "224",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "227",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "82",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "88",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "305",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "352",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "144",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "168",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "215",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "211",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "58",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "66",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "608",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "611",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "113",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "152",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "28",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "60",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "96",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "112",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "77",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "86",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "114",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "167",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "107",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "240",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "83",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "122",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "70",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "66",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "89",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "98",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "242",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "427",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2383",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2474",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "884",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "953",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1421",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1438",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "78",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "83",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "5876",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "5859",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "621",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "598",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "3238",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "3224",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2017",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2037",
    "": ""
  },
  {
    "Codes": "17",
    "Stadtteil": "Niederrad",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "22108",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "22396",
    "Bevölkerungsstruktur Frauen in %  2011": "50,9",
    "Bevölkerungsstruktur Frauen in %  2012": "50,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "2,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "3,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "4,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "12691",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "10953",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2974",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4565",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "6443",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "6878",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "29,1",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "30,7",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,9",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "41,7",
    "Bevölkerungsstruktur Jugendquotient  2011": "23,2",
    "Bevölkerungsstruktur Jugendquotient  2012": "22,8",
    "Bevölkerungsstruktur Altenquotient  2011": "24,9",
    "Bevölkerungsstruktur Altenquotient  2012": "24,3",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1220",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1242",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,6",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "736",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "271",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "319",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "779",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "165",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "192",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1264",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1220",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "51,1",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "50,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "634",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "315",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "400",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "693",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "230",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "212",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "628",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "632",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "47,6",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "50,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "278",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "215",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "136",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "210",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "214",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "207",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "3914",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "4170",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "54,0",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "53,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "2046",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "2036",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "571",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "693",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1297",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1441",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "11358",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "11437",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "48,4",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "48,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "6045",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "5575",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1413",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1722",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "3900",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "4140",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3724",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3695",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "56,2",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "55,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2952",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2541",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "135",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "468",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "637",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "686",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "48,6",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "47,6",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "2419",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2700",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "45,0",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "44,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "49,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "50,3",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "682",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1212",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "51,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "53,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "4884",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "5258",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "430",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "446",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "235",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "228",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "874",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "929",
    "Bevölkerungsstruktur Staatenlose  2011": "20",
    "Bevölkerungsstruktur Staatenlose  2012": "17",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "124",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "121",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "164",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "204",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "154",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "163",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "356",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "363",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "702",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "709",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "190",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "199",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "334",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "373",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "152",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "212",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "397",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "432",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "275",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "295",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "955",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "943",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "91",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "136",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "66",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "141",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "109",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "136",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "84",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "123",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "312",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "400",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "228",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "398",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "98",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "126",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "99",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "116",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "166",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "184",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "377",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "618",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "4936",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "5355",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "2170",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "2421",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "2634",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "2787",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "132",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "147",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "10390",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "10277",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1264",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1269",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "5733",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "5661",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "3393",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "3347",
    "": ""
  },
  {
    "Codes": "18",
    "Stadtteil": "Schwanheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "20209",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "20480",
    "Bevölkerungsstruktur Frauen in %  2011": "51,4",
    "Bevölkerungsstruktur Frauen in %  2012": "51,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "0,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "1,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "0,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "2,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "12803",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "10997",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "3365",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "5176",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "4041",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "4307",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "20,0",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "21,0",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "42,6",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,4",
    "Bevölkerungsstruktur Jugendquotient  2011": "35,2",
    "Bevölkerungsstruktur Jugendquotient  2012": "35,4",
    "Bevölkerungsstruktur Altenquotient  2011": "34,5",
    "Bevölkerungsstruktur Altenquotient  2012": "33,9",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1282",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1315",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "869",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "334",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "314",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "861",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "99",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "120",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1713",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1747",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,6",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "990",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "567",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "511",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "990",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "212",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "190",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "769",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "815",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "46,2",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "46,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "381",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "303",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "215",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "322",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "173",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "190",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2871",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2911",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,8",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "51,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1498",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1455",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "642",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "660",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "731",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "796",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "9467",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "9588",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,2",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "50,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "5488",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "5206",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1512",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1775",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2467",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2607",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "4107",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "4104",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,0",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "56,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "3577",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "3132",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "171",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "568",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "359",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "404",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "50,7",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "50,4",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1119",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1285",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,2",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "47,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "48,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,3",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "735",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1328",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "52,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "54,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2930",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "3090",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "494",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "534",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "117",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "120",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "453",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "518",
    "Bevölkerungsstruktur Staatenlose  2011": "47",
    "Bevölkerungsstruktur Staatenlose  2012": "45",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "105",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "108",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "68",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "70",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "72",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "87",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "264",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "274",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "264",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "270",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "241",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "256",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "193",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "232",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "48",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "102",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "179",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "179",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "135",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "144",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "1139",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "1116",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "176",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "250",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "73",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "178",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "35",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "43",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "101",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "140",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "530",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "768",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "346",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "616",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "98",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "141",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "112",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "112",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "290",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "262",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "467",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "756",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2169",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2303",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "841",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "915",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1221",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1282",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "107",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "106",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "11656",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "11600",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1645",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1625",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "6186",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "6157",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "3825",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "3818",
    "": ""
  },
  {
    "Codes": "19",
    "Stadtteil": "Griesheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "22629",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "23124",
    "Bevölkerungsstruktur Frauen in %  2011": "45,6",
    "Bevölkerungsstruktur Frauen in %  2012": "45,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "10,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "13,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "7,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "8,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "9670",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "8175",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "4264",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "5870",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "8695",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "9079",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "38,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "39,3",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "40,0",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "40,0",
    "Bevölkerungsstruktur Jugendquotient  2011": "27,9",
    "Bevölkerungsstruktur Jugendquotient  2012": "27,3",
    "Bevölkerungsstruktur Altenquotient  2011": "20,2",
    "Bevölkerungsstruktur Altenquotient  2012": "19,5",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1337",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1348",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "52,1",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "51,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "664",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "181",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "427",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "934",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "246",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "233",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1665",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1657",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "50,2",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "50,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "654",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "279",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "564",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "965",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "447",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "413",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "811",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "843",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "46,6",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "49,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "266",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "175",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "232",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "345",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "313",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "323",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "4017",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "4084",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "47,0",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "45,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1407",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1397",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "844",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "871",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1766",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1816",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "11717",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "12128",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "41,1",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "40,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "4334",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "4110",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "2065",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "2375",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "5318",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "5643",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3082",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3064",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "55,7",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "55,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2345",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2033",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "132",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "380",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "605",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "651",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "42,8",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "42,0",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "3723",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "4113",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "35,1",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "34,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "39,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "42,4",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "1505",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1866",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "24,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "32,0",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "6900",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "7253",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "902",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "891",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "118",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "111",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "725",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "773",
    "Bevölkerungsstruktur Staatenlose  2011": "50",
    "Bevölkerungsstruktur Staatenlose  2012": "51",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "114",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "117",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "346",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "330",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "401",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "415",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "737",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "741",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "405",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "415",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "376",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "373",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "947",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "1059",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "572",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "646",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "487",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "487",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "134",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "147",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "1666",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "1622",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "116",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "163",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "106",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "238",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "57",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "64",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "115",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "152",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "625",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "848",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "1057",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "1168",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "115",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "150",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "134",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "137",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "146",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "157",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "572",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "857",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "5412",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "5680",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1976",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "2045",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "3350",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "3540",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "86",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "95",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "9769",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "9843",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1399",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1414",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "5499",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "5591",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2871",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2838",
    "": ""
  },
  {
    "Codes": "20",
    "Stadtteil": "Rödelheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "16890",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "17026",
    "Bevölkerungsstruktur Frauen in %  2011": "50,3",
    "Bevölkerungsstruktur Frauen in %  2012": "50,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "2,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "2,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "2,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "3,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "9911",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "8765",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2315",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3481",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "4664",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "4780",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "27,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "28,1",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,8",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "41,8",
    "Bevölkerungsstruktur Jugendquotient  2011": "26,1",
    "Bevölkerungsstruktur Jugendquotient  2012": "25,9",
    "Bevölkerungsstruktur Altenquotient  2011": "26,1",
    "Bevölkerungsstruktur Altenquotient  2012": "26,1",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1027",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "986",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "47,7",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "639",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "286",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "228",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "545",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "160",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "155",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1127",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1149",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "47,6",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "46,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "586",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "349",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "303",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "578",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "238",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "222",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "466",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "503",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "50,6",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "52,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "203",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "162",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "118",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "186",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "145",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "155",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2735",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2776",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,1",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "51,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1344",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1321",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "485",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "520",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "906",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "935",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "8640",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "8691",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "48,8",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "4789",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "4542",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1076",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1298",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2775",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2851",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2895",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2921",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "54,8",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "54,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2350",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2105",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "105",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "354",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "440",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "462",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "48,7",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "49,0",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1912",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2022",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,0",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "47,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "49,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "48,8",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "509",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "899",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "48,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "50,9",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "3453",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "3547",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "321",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "322",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "139",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "156",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "700",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "704",
    "Bevölkerungsstruktur Staatenlose  2011": "51",
    "Bevölkerungsstruktur Staatenlose  2012": "51",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "115",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "116",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "106",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "101",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "157",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "155",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "404",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "408",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "251",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "255",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "122",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "113",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "367",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "371",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "110",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "136",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "195",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "192",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "154",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "175",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "755",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "738",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "69",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "112",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "75",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "145",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "96",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "113",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "81",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "89",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "243",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "301",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "159",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "293",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "62",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "100",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "93",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "84",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "141",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "149",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "271",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "425",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "3411",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "3521",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1433",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1474",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1881",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1941",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "97",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "106",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "7935",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "7927",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "906",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "918",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "4377",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "4335",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2652",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2674",
    "": ""
  },
  {
    "Codes": "21",
    "Stadtteil": "Hausen",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "7025",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "7172",
    "Bevölkerungsstruktur Frauen in %  2011": "50,9",
    "Bevölkerungsstruktur Frauen in %  2012": "51,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "8,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "9,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "5,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "3543",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "2977",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1317",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "1928",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "2165",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2267",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "30,8",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "31,6",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "40,8",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "40,8",
    "Bevölkerungsstruktur Jugendquotient  2011": "30,4",
    "Bevölkerungsstruktur Jugendquotient  2012": "29,6",
    "Bevölkerungsstruktur Altenquotient  2011": "27,0",
    "Bevölkerungsstruktur Altenquotient  2012": "26,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "446",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "433",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "46,4",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "209",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "62",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "135",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "270",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "102",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "101",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "536",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "539",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,6",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "212",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "85",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "172",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "304",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "152",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "150",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "239",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "237",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "48,5",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "46,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "100",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "63",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "85",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "121",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "54",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "53",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1347",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1431",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,4",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "51,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "454",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "449",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "251",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "290",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "642",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "692",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "3253",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "3304",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,3",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "50,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "1528",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "1423",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "615",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "732",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1110",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1149",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "1204",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "1228",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "55,6",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "55,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1040",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "895",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "59",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "211",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "105",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "122",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "50,4",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "50,6",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "506",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "549",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,6",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "47,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "49,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,7",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "197",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "424",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "53,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "52,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1087",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1127",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "184",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "200",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "65",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "55",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "819",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "876",
    "Bevölkerungsstruktur Staatenlose  2011": "10",
    "Bevölkerungsstruktur Staatenlose  2012": "9",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "106",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "105",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "24",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "24",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "58",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "60",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "100",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "108",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "43",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "49",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "80",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "85",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "78",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "90",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "25",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "33",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "65",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "63",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "33",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "44",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "316",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "296",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "80",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "115",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "62",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "92",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "88",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "103",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "23",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "29",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "265",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "298",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "75",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "179",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "16",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "20",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "40",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "27",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "68",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "81",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "119",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "206",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1472",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "1600",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "746",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "827",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "698",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "732",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "28",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "41",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "3265",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "3310",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "423",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "439",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "1737",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "1757",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "1105",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "1114",
    "": ""
  },
  {
    "Codes": "22",
    "Stadtteil": "Praunheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "15494",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "15700",
    "Bevölkerungsstruktur Frauen in %  2011": "52,3",
    "Bevölkerungsstruktur Frauen in %  2012": "52,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "0,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "1,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "1,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "3,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "9795",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "8681",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2318",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3479",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3381",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "3540",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "21,8",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "22,5",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "43,3",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "43,2",
    "Bevölkerungsstruktur Jugendquotient  2011": "32,3",
    "Bevölkerungsstruktur Jugendquotient  2012": "32,3",
    "Bevölkerungsstruktur Altenquotient  2011": "34,1",
    "Bevölkerungsstruktur Altenquotient  2012": "33,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "896",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "923",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "47,9",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "47,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "543",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "238",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "244",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "559",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "109",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "126",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1176",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1192",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,0",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "637",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "357",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "304",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "611",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "235",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "224",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "668",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "642",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "47,6",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "46,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "365",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "293",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "166",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "206",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "137",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "143",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2051",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2146",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "51,6",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "52,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1068",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1070",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "401",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "456",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "582",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "620",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "7531",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "7601",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "51,5",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "51,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "4449",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "4282",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1089",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1242",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1993",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2077",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3172",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3196",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "58,8",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "58,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2733",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2441",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "114",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "405",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "325",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "350",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "52,1",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "52,0",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1028",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1159",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "49,9",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "48,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "47,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,4",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "515",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "954",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "46,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "50,8",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2364",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2513",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "315",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "312",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "87",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "100",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "596",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "594",
    "Bevölkerungsstruktur Staatenlose  2011": "19",
    "Bevölkerungsstruktur Staatenlose  2012": "21",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "109",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "102",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "63",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "78",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "80",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "78",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "196",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "217",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "231",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "238",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "146",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "141",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "225",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "238",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "66",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "111",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "126",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "129",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "68",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "73",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "710",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "701",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "69",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "90",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "73",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "138",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "114",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "128",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "74",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "104",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "364",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "420",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "246",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "431",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "43",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "78",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "85",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "74",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "139",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "182",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "256",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "417",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1975",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2070",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "740",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "772",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1164",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1212",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "71",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "86",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "8625",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "8712",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1006",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1066",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "4689",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "4696",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2930",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2950",
    "": ""
  },
  {
    "Codes": "24",
    "Stadtteil": "Heddernheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "16625",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "16747",
    "Bevölkerungsstruktur Frauen in %  2011": "53,0",
    "Bevölkerungsstruktur Frauen in %  2012": "52,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "3,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "2,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "2,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "2,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "10349",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "9165",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2835",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4040",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3441",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "3542",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "20,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "21,2",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "42,0",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,1",
    "Bevölkerungsstruktur Jugendquotient  2011": "32,9",
    "Bevölkerungsstruktur Jugendquotient  2012": "32,8",
    "Bevölkerungsstruktur Altenquotient  2011": "30,6",
    "Bevölkerungsstruktur Altenquotient  2012": "30,1",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1033",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1020",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "50,9",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "620",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "280",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "339",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "659",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "74",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "81",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1288",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1306",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,5",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "689",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "426",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "426",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "718",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "173",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "162",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "665",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "691",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "50,5",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "50,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "382",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "314",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "162",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "246",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "121",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "131",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2448",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2482",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "53,1",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "53,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1312",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1304",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "507",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "537",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "629",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "641",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "8077",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "8151",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "51,9",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "51,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "4735",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "4524",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1261",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1468",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2081",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2159",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3114",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3097",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "58,5",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "58,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2611",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2317",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "140",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "412",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "363",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "368",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "52,2",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "52,6",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1133",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1214",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "50,4",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "50,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "51,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "51,4",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "646",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1080",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "52,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "56,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2501",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2585",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "380",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "388",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "114",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "103",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "435",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "456",
    "Bevölkerungsstruktur Staatenlose  2011": "11",
    "Bevölkerungsstruktur Staatenlose  2012": "10",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "108",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "104",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "75",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "75",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "106",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "109",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "405",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "405",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "224",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "242",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "197",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "198",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "170",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "192",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "45",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "63",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "143",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "143",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "75",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "90",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "760",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "733",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "92",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "111",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "104",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "151",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "148",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "166",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "134",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "170",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "481",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "552",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "242",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "421",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "77",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "105",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "92",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "81",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "142",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "162",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "333",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "565",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1966",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2079",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "790",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "830",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1119",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1193",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "57",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "56",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "9311",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "9286",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1336",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1312",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "5051",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "5060",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2924",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2914",
    "": ""
  },
  {
    "Codes": "25",
    "Stadtteil": "Niederursel",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "14975",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "15081",
    "Bevölkerungsstruktur Frauen in %  2011": "51,7",
    "Bevölkerungsstruktur Frauen in %  2012": "51,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "4,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "3,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "3,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "8759",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "7625",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2789",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4008",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3427",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "3448",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "22,9",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "22,9",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "42,9",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,9",
    "Bevölkerungsstruktur Jugendquotient  2011": "35,2",
    "Bevölkerungsstruktur Jugendquotient  2012": "35,0",
    "Bevölkerungsstruktur Altenquotient  2011": "36,8",
    "Bevölkerungsstruktur Altenquotient  2012": "35,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "903",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "951",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,7",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "500",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "200",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "310",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "648",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "93",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "103",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1286",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1256",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "44,8",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "45,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "636",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "341",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "431",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "730",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "219",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "185",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "595",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "572",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "47,1",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "45,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "296",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "205",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "155",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "248",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "144",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "119",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1952",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1994",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "51,5",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "53,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "928",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "932",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "460",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "500",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "564",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "562",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "7037",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "7149",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,2",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "50,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3652",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "3541",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1283",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1459",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2102",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2149",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3202",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3159",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "59,1",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "59,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2747",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2406",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "150",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "423",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "305",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "330",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "52,3",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "52,8",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "953",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1007",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "52,5",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "51,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "48,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,2",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "541",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "991",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "51,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "51,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2378",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2367",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "280",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "281",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "84",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "92",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "672",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "694",
    "Bevölkerungsstruktur Staatenlose  2011": "13",
    "Bevölkerungsstruktur Staatenlose  2012": "14",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "107",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "107",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "78",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "78",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "87",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "86",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "245",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "260",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "218",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "191",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "153",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "156",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "147",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "180",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "31",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "39",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "96",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "100",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "49",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "54",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "850",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "810",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "92",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "112",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "63",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "115",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "136",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "149",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "52",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "72",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "417",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "502",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "262",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "432",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "48",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "76",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "78",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "78",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "174",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "227",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "381",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "537",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1954",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2000",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "707",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "715",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1175",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1197",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "72",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "88",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "7954",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "7966",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "975",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "968",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "4021",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "4089",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2958",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2909",
    "": ""
  },
  {
    "Codes": "26",
    "Stadtteil": "Ginnheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "16153",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "16346",
    "Bevölkerungsstruktur Frauen in %  2011": "52,8",
    "Bevölkerungsstruktur Frauen in %  2012": "52,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "5,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "5,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "1,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "2,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "9343",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "8017",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "3221",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4674",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3589",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "3655",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "22,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "22,4",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "40,3",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "40,4",
    "Bevölkerungsstruktur Jugendquotient  2011": "37,5",
    "Bevölkerungsstruktur Jugendquotient  2012": "36,5",
    "Bevölkerungsstruktur Altenquotient  2011": "27,0",
    "Bevölkerungsstruktur Altenquotient  2012": "26,7",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1005",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "987",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,9",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "50,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "677",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "270",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "242",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "624",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "86",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "93",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1438",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1430",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,9",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "778",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "411",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "467",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "857",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "193",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "162",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "811",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "803",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "49,9",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "49,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "363",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "251",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "268",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "372",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "180",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "180",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2479",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2609",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "51,8",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "51,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1187",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1200",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "665",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "781",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "627",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "628",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "7768",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "7844",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "52,4",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "52,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "4172",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "3944",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1444",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1682",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2152",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2218",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2652",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2673",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "59,0",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "58,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2166",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1941",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "135",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "358",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "351",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "374",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "52,8",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "52,5",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1102",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1182",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "53,4",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "52,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "50,8",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "554",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "972",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "56,1",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "57,8",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2565",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2640",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "309",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "309",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "124",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "128",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "577",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "567",
    "Bevölkerungsstruktur Staatenlose  2011": "14",
    "Bevölkerungsstruktur Staatenlose  2012": "11",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "113",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "112",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "65",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "70",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "124",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "144",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "242",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "252",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "293",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "272",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "132",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "125",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "209",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "220",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "32",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "62",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "172",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "190",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "80",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "68",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "638",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "628",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "184",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "232",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "109",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "225",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "262",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "296",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "95",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "117",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "387",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "524",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "193",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "333",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "51",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "75",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "82",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "87",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "174",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "188",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "354",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "580",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2132",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2191",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "807",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "880",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1251",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1243",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "74",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "68",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "8063",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "8215",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1297",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1381",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "4388",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "4430",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2378",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2404",
    "": ""
  },
  {
    "Codes": "27",
    "Stadtteil": "Dornbusch",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "17688",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "17817",
    "Bevölkerungsstruktur Frauen in %  2011": "53,9",
    "Bevölkerungsstruktur Frauen in %  2012": "53,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "4,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "4,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "2,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "12110",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "10847",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2140",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3474",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3438",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "3496",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "19,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "19,6",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "44,0",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "44,0",
    "Bevölkerungsstruktur Jugendquotient  2011": "26,6",
    "Bevölkerungsstruktur Jugendquotient  2012": "26,3",
    "Bevölkerungsstruktur Altenquotient  2011": "35,2",
    "Bevölkerungsstruktur Altenquotient  2012": "35,0",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "961",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "953",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "50,3",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "666",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "350",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "196",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "510",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "99",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "93",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1204",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1197",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "47,6",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "822",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "563",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "229",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "488",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "153",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "146",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "485",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "492",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "49,9",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "52,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "303",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "245",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "85",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "144",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "97",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "103",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2599",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2604",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "53,9",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "53,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1467",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1453",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "422",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "476",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "710",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "675",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "8589",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "8705",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "52,3",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "52,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "5476",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "5266",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1080",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1333",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2033",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2106",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3850",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3866",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "60,9",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "61,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "3376",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2970",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "128",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "523",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "346",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "373",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "52,4",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "53,6",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1335",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1377",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "51,4",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "52,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "51,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "52,6",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "576",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1136",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "56,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "56,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2440",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2501",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "209",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "217",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "194",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "205",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "585",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "564",
    "Bevölkerungsstruktur Staatenlose  2011": "10",
    "Bevölkerungsstruktur Staatenlose  2012": "9",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "112",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "118",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "87",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "87",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "115",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "122",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "309",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "290",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "265",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "261",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "83",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "84",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "190",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "211",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "55",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "68",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "168",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "167",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "104",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "124",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "406",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "409",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "29",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "51",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "43",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "77",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "155",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "190",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "72",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "118",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "141",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "225",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "163",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "359",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "90",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "135",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "74",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "91",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "118",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "153",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "229",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "386",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "3080",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "3107",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1276",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1263",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1657",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1690",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "147",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "154",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "8866",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "8920",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "963",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "975",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "4432",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "4470",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "3471",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "3475",
    "": ""
  },
  {
    "Codes": "28",
    "Stadtteil": "Eschersheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "14234",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "14381",
    "Bevölkerungsstruktur Frauen in %  2011": "53,1",
    "Bevölkerungsstruktur Frauen in %  2012": "53,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "7,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "8,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "5,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "4,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "10057",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "9169",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1591",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "2538",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "2586",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2674",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "18,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "18,6",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "42,4",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,4",
    "Bevölkerungsstruktur Jugendquotient  2011": "27,5",
    "Bevölkerungsstruktur Jugendquotient  2012": "27,6",
    "Bevölkerungsstruktur Altenquotient  2011": "29,2",
    "Bevölkerungsstruktur Altenquotient  2012": "29,1",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "828",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "832",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "51,6",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "51,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "590",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "355",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "139",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "374",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "99",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "103",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "964",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "967",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "47,9",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "675",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "493",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "178",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "353",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "111",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "121",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "472",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "489",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "50,8",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "50,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "300",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "254",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "81",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "144",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "91",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "91",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2262",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2259",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,4",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "53,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1346",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1323",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "362",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "389",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "554",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "547",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "7057",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "7164",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "51,8",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "51,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "4765",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "4599",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "770",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "970",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1522",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1595",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2651",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2670",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "59,7",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "59,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2381",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2145",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "61",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "308",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "209",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "217",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,0",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "52,0",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1022",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1120",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "50,7",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "50,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "420",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "845",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "52,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "53,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1926",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2017",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "158",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "147",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "141",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "136",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "349",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "358",
    "Bevölkerungsstruktur Staatenlose  2011": "12",
    "Bevölkerungsstruktur Staatenlose  2012": "16",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "103",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "100",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "84",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "88",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "56",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "59",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "231",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "232",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "168",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "164",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "66",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "69",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "230",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "263",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "44",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "81",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "132",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "124",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "52",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "60",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "396",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "366",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "52",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "78",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "29",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "56",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "84",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "106",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "50",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "87",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "126",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "185",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "156",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "302",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "57",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "97",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "48",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "51",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "120",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "130",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "160",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "248",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2577",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2594",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1058",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1073",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1428",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1429",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "91",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "92",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "6960",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "6961",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "875",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "858",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "3659",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "3682",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2426",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2421",
    "": ""
  },
  {
    "Codes": "29",
    "Stadtteil": "Eckenheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "13994",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "14062",
    "Bevölkerungsstruktur Frauen in %  2011": "52,1",
    "Bevölkerungsstruktur Frauen in %  2012": "51,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "3,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "4,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "2,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "2,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "7716",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "6611",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2528",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3635",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3750",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "3816",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "26,8",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "27,1",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,7",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "41,9",
    "Bevölkerungsstruktur Jugendquotient  2011": "29,1",
    "Bevölkerungsstruktur Jugendquotient  2012": "28,7",
    "Bevölkerungsstruktur Altenquotient  2011": "27,6",
    "Bevölkerungsstruktur Altenquotient  2012": "27,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "825",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "813",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "50,5",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "506",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "188",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "236",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "541",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "83",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "84",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1004",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "983",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,1",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "48,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "521",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "267",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "322",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "581",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "161",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "135",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "492",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "495",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "47,0",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "46,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "206",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "155",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "144",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "208",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "142",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "132",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2392",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2398",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,8",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "51,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1111",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1065",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "520",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "560",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "761",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "773",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "6815",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "6875",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "51,0",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "50,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3464",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "3288",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1160",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1343",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2191",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2244",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2466",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2498",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "59,3",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "58,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1908",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1648",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "146",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "402",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "412",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "448",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,8",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "51,3",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1037",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1104",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "47,3",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "46,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "49,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,9",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "428",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "743",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "51,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "54,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2651",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2672",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "350",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "360",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "144",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "157",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "592",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "617",
    "Bevölkerungsstruktur Staatenlose  2011": "13",
    "Bevölkerungsstruktur Staatenlose  2012": "10",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "109",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "107",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "82",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "95",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "69",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "75",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "260",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "254",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "303",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "298",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "147",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "141",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "175",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "202",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "78",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "82",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "160",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "148",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "65",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "71",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "861",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "829",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "118",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "184",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "78",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "156",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "146",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "162",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "68",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "71",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "276",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "377",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "155",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "297",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "51",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "70",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "68",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "54",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "157",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "183",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "327",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "471",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2273",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2351",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1003",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1020",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1166",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1210",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "104",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "121",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "7033",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "7040",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1031",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1011",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "3811",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "3824",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2191",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2205",
    "": ""
  },
  {
    "Codes": "30",
    "Stadtteil": "Preungesheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "13534",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "13934",
    "Bevölkerungsstruktur Frauen in %  2011": "51,5",
    "Bevölkerungsstruktur Frauen in %  2012": "51,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "70,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "71,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "18,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "16,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "7719",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "6671",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2330",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3667",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3485",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "3596",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "25,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "25,8",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "38,5",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "38,7",
    "Bevölkerungsstruktur Jugendquotient  2011": "38,5",
    "Bevölkerungsstruktur Jugendquotient  2012": "37,3",
    "Bevölkerungsstruktur Altenquotient  2011": "22,1",
    "Bevölkerungsstruktur Altenquotient  2012": "21,6",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1125",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1082",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,3",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "738",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "320",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "276",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "647",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "111",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "115",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1326",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1393",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,0",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "758",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "429",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "383",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "793",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "185",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "171",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "510",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "532",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "49,4",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "50,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "228",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "180",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "134",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "206",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "148",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "146",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1923",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1948",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "53,7",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "52,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "910",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "899",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "380",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "442",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "633",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "607",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "6790",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "7082",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,3",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3572",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "3524",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1079",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1297",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2139",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2261",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "1860",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "1897",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,2",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "57,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1513",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1319",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "78",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "282",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "269",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "296",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,5",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "50,4",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1156",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1274",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "51,0",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "49,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "50,7",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "522",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "936",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "54,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "53,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2604",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2708",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "395",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "372",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "95",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "102",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "385",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "407",
    "Bevölkerungsstruktur Staatenlose  2011": "6",
    "Bevölkerungsstruktur Staatenlose  2012": "7",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "104",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "106",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "124",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "122",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "89",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "83",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "304",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "308",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "325",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "335",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "123",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "114",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "219",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "250",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "56",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "67",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "203",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "202",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "56",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "64",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "660",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "633",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "71",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "101",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "43",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "101",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "102",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "137",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "82",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "124",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "206",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "296",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "197",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "349",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "64",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "90",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "126",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "118",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "145",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "184",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "315",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "551",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2145",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2234",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "746",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "767",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1291",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1362",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "108",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "105",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "5866",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "6015",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "823",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "840",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "3434",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "3547",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "1609",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "1628",
    "": ""
  },
  {
    "Codes": "31",
    "Stadtteil": "Bonames",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "6103",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "6139",
    "Bevölkerungsstruktur Frauen in %  2011": "51,7",
    "Bevölkerungsstruktur Frauen in %  2012": "52,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "-0,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "0,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "1,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "1,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "3697",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "3078",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1141",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "1797",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "1265",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "1264",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "20,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "20,6",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "43,2",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "43,1",
    "Bevölkerungsstruktur Jugendquotient  2011": "30,8",
    "Bevölkerungsstruktur Jugendquotient  2012": "31,5",
    "Bevölkerungsstruktur Altenquotient  2011": "31,6",
    "Bevölkerungsstruktur Altenquotient  2012": "31,3",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "335",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "360",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "45,7",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "227",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "85",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "78",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "242",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "30",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "33",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "450",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "439",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "51,8",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "292",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "129",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "109",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "266",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "49",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "44",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "256",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "269",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "50,4",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "52,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "141",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "105",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "62",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "118",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "53",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "46",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "848",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "844",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,6",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "52,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "441",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "411",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "207",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "226",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "200",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "207",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "3028",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "3048",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,4",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "50,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "1652",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "1572",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "594",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "707",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "782",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "769",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "1186",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "1179",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,7",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "57,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "944",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "776",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "91",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "238",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "151",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "165",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "50,1",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "52,1",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "534",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "497",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,5",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "50,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "51,1",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "297",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "543",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "54,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "53,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "936",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "901",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "137",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "148",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "24",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "33",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "159",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "173",
    "Bevölkerungsstruktur Staatenlose  2011": "9",
    "Bevölkerungsstruktur Staatenlose  2012": "9",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "77",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "80",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "26",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "26",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "104",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "119",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "74",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "80",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "72",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "71",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "74",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "77",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "102",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "100",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "74",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "31",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "45",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "43",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "48",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "44",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "192",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "181",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "78",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "107",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "34",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "67",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "25",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "30",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "21",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "31",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "101",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "137",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "183",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "311",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "34",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "47",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "24",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "16",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "98",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "134",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "91",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "138",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "822",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "835",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "280",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "282",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "506",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "512",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "36",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "41",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "3319",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "3322",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "439",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "430",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "1803",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "1822",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "1077",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "1070",
    "": ""
  },
  {
    "Codes": "32",
    "Stadtteil": "Berkersheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "3473",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "3643",
    "Bevölkerungsstruktur Frauen in %  2011": "51,6",
    "Bevölkerungsstruktur Frauen in %  2012": "51,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "15,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "18,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "7,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "12,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "2320",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "2073",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "591",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "959",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "562",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "611",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "16,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "16,8",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "39,3",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "38,9",
    "Bevölkerungsstruktur Jugendquotient  2011": "44,5",
    "Bevölkerungsstruktur Jugendquotient  2012": "45,8",
    "Bevölkerungsstruktur Altenquotient  2011": "27,3",
    "Bevölkerungsstruktur Altenquotient  2012": "25,9",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "234",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "252",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "51,3",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "50,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "176",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "94",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "41",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "138",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "17",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "20",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "403",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "417",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,1",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "48,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "260",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "173",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "97",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "207",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "46",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "37",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "184",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "210",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "38,6",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "40,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "100",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "83",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "55",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "92",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "29",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "35",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "444",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "463",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,7",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "52,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "246",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "244",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "101",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "118",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "97",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "101",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "1657",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "1752",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "52,7",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "52,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "1049",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "1032",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "278",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "344",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "330",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "376",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "551",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "549",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "53,5",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "53,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "489",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "447",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "19",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "60",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "43",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "42",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "53,6",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "53,5",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "228",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "248",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "50,4",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "52,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "52,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "50,3",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "108",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "216",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "51,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "48,1",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "370",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "390",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "54",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "53",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "40",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "41",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "98",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "127",
    "Bevölkerungsstruktur Staatenlose  2011": "0",
    "Bevölkerungsstruktur Staatenlose  2012": "0",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "61",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "72",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "9",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "8",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "17",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "17",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "36",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "41",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "33",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "35",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "29",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "27",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "57",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "56",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "3",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "5",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "12",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "10",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "10",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "10",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "69",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "69",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "44",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "66",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "13",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "29",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "54",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "71",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "20",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "22",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "119",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "149",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "51",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "106",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "13",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "19",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "9",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "19",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "31",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "35",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "45",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "75",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "399",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "432",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "149",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "141",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "230",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "270",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "20",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "21",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "1764",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "1794",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "242",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "257",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "1022",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "1035",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "500",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "502",
    "": ""
  },
  {
    "Codes": "33",
    "Stadtteil": "Riederwald",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "4670",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "4664",
    "Bevölkerungsstruktur Frauen in %  2011": "51,4",
    "Bevölkerungsstruktur Frauen in %  2012": "51,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "0,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "-0,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "1,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "1,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "2802",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "2458",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "753",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "1052",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "1115",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "1154",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "23,9",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "24,7",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,1",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,6",
    "Bevölkerungsstruktur Jugendquotient  2011": "29,2",
    "Bevölkerungsstruktur Jugendquotient  2012": "27,6",
    "Bevölkerungsstruktur Altenquotient  2011": "27,2",
    "Bevölkerungsstruktur Altenquotient  2012": "28,2",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "309",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "291",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "52,1",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "187",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "75",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "86",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "180",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "36",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "36",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "329",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "310",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,9",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "51,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "182",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "94",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "104",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "182",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "43",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "34",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "148",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "155",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "46,6",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "48,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "60",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "60",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "48",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "61",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "40",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "34",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "676",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "648",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,2",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "51,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "342",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "309",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "143",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "147",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "191",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "192",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "2395",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "2415",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "49,7",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "1377",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "1299",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "329",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "385",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "689",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "731",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "813",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "845",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,3",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "56,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "654",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "621",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "43",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "97",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "116",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "127",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,4",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "51,7",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "291",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "304",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "48,1",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "50,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "45,3",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "46,7",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "125",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "202",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "56,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "55,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "784",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "812",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "181",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "191",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "37",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "38",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "109",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "109",
    "Bevölkerungsstruktur Staatenlose  2011": "4",
    "Bevölkerungsstruktur Staatenlose  2012": "4",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "79",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "80",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "33",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "44",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "15",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "17",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "102",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "101",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "87",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "85",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "89",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "92",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "49",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "44",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "10",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "9",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "63",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "65",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "13",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "20",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "261",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "257",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "16",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "20",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "40",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "67",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "25",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "23",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "34",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "36",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "149",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "156",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "47",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "83",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "4",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "6",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "24",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "22",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "36",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "36",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "110",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "153",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "612",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "626",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "223",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "219",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "368",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "386",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "21",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "21",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "2459",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "2433",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "319",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "300",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "1388",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "1359",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "752",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "774",
    "": ""
  },
  {
    "Codes": "34",
    "Stadtteil": "Seckbach",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "9706",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "9938",
    "Bevölkerungsstruktur Frauen in %  2011": "51,6",
    "Bevölkerungsstruktur Frauen in %  2012": "51,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "4,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "7,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "6,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "6479",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "5836",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1142",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "1775",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "2085",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2327",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "21,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "23,4",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "44,8",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "44,4",
    "Bevölkerungsstruktur Jugendquotient  2011": "28,8",
    "Bevölkerungsstruktur Jugendquotient  2012": "28,5",
    "Bevölkerungsstruktur Altenquotient  2011": "37,2",
    "Bevölkerungsstruktur Altenquotient  2012": "35,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "521",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "530",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "52,4",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "54,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "369",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "208",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "103",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "269",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "49",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "53",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "691",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "704",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,8",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "48,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "443",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "316",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "142",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "283",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "106",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "105",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "304",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "330",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "48,7",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "50,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "202",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "177",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "51",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "80",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "51",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "73",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1295",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1348",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,5",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "718",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "685",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "210",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "225",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "367",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "438",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "4720",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "4860",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "48,3",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "48,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "2852",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "2766",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "566",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "669",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1302",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1425",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2175",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2166",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "60,4",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "59,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1895",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1684",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "70",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "249",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "210",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "233",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "46,1",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "46,0",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "842",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1046",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "41,9",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "41,1",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "46,1",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "48,6",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "342",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "624",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "42,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "47,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1680",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1891",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "128",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "150",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "72",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "74",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "184",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "191",
    "Bevölkerungsstruktur Staatenlose  2011": "21",
    "Bevölkerungsstruktur Staatenlose  2012": "21",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "96",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "97",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "99",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "82",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "34",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "40",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "166",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "173",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "160",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "174",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "41",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "53",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "164",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "222",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "90",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "156",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "125",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "119",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "40",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "43",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "345",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "359",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "19",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "23",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "21",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "39",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "37",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "46",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "49",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "64",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "70",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "113",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "165",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "264",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "33",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "60",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "51",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "41",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "55",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "72",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "143",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "215",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1584",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "1685",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "553",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "596",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "933",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "992",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "98",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "97",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "5139",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "5134",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "549",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "552",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "2637",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "2634",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "1953",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "1948",
    "": ""
  },
  {
    "Codes": "35",
    "Stadtteil": "Fechenheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "15615",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "15913",
    "Bevölkerungsstruktur Frauen in %  2011": "49,6",
    "Bevölkerungsstruktur Frauen in %  2012": "49,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "2,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "3,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "2,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "4,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "7398",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "6214",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2591",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3834",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "5626",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "5865",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "36,0",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "36,9",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "39,8",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "39,7",
    "Bevölkerungsstruktur Jugendquotient  2011": "35,2",
    "Bevölkerungsstruktur Jugendquotient  2012": "35,0",
    "Bevölkerungsstruktur Altenquotient  2011": "25,0",
    "Bevölkerungsstruktur Altenquotient  2012": "24,4",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1071",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1085",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,7",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "522",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "176",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "351",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "694",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "198",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "215",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1342",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1415",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,9",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "534",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "234",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "476",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "844",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "332",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "337",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "676",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "659",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "46,9",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "48,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "240",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "173",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "182",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "245",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "254",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "241",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2595",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2674",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,3",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "972",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "942",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "442",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "517",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1181",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1215",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "7493",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "7641",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "47,3",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "46,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3203",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "2973",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1049",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1256",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "3241",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "3412",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2438",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2439",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,0",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "56,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1927",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1716",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "91",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "278",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "420",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "445",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "48,1",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "47,1",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1886",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2131",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "44,6",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "43,1",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "47,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "48,5",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "437",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "790",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "46,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "50,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "4279",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "4512",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "553",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "545",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "99",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "94",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "619",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "640",
    "Bevölkerungsstruktur Staatenlose  2011": "76",
    "Bevölkerungsstruktur Staatenlose  2012": "74",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "107",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "105",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "196",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "192",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "88",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "93",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "551",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "548",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "262",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "284",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "201",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "196",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "374",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "403",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "258",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "337",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "394",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "412",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "71",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "77",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "1415",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "1351",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "130",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "218",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "51",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "134",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "68",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "78",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "100",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "116",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "276",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "365",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "163",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "312",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "36",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "64",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "113",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "120",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "114",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "117",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "507",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "768",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2960",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "3196",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1182",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1246",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1703",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1861",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "75",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "89",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "7061",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "7016",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "981",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1007",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "3834",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "3780",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2246",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2229",
    "": ""
  },
  {
    "Codes": "36",
    "Stadtteil": "Höchst",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "13751",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "14143",
    "Bevölkerungsstruktur Frauen in %  2011": "48,8",
    "Bevölkerungsstruktur Frauen in %  2012": "48,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "16,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "16,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "4,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "6,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "6339",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "5398",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2253",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3379",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "5159",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "5366",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "37,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "37,9",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "37,1",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "37,0",
    "Bevölkerungsstruktur Jugendquotient  2011": "31,8",
    "Bevölkerungsstruktur Jugendquotient  2012": "31,6",
    "Bevölkerungsstruktur Altenquotient  2011": "14,6",
    "Bevölkerungsstruktur Altenquotient  2012": "14,2",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "922",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "931",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "47,3",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "529",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "190",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "241",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "568",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "152",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "173",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1212",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1243",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "47,9",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "48,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "506",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "224",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "389",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "697",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "317",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "322",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "534",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "591",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "46,1",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "46,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "176",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "115",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "140",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "245",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "218",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "231",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2708",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2782",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,3",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1159",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1157",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "461",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "512",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1088",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1113",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "7008",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "7219",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "47,5",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "47,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3045",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "2888",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "967",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1204",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2996",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "3127",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "1367",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "1377",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "55,0",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "53,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "924",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "824",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "55",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "153",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "388",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "400",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "47,9",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "47,5",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "2184",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2349",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "46,3",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "46,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "46,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "46,6",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "438",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "733",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "50,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "50,3",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "3935",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "4114",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "463",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "473",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "89",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "88",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "642",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "666",
    "Bevölkerungsstruktur Staatenlose  2011": "30",
    "Bevölkerungsstruktur Staatenlose  2012": "25",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "105",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "111",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "183",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "195",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "211",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "217",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "467",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "464",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "259",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "257",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "231",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "225",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "279",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "312",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "184",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "241",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "282",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "299",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "192",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "195",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "876",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "854",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "124",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "184",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "55",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "126",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "31",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "43",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "83",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "105",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "291",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "363",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "159",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "275",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "31",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "38",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "109",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "96",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "171",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "192",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "287",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "448",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "3277",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "3375",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1361",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1405",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1848",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1892",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "68",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "78",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "5039",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "5119",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "824",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "841",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "3017",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "3088",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "1198",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "1190",
    "": ""
  },
  {
    "Codes": "37",
    "Stadtteil": "Nied",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "18056",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "18294",
    "Bevölkerungsstruktur Frauen in %  2011": "50,1",
    "Bevölkerungsstruktur Frauen in %  2012": "50,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "8,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "9,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "6,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "5,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "9381",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "7980",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2996",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4505",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "5679",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "5809",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "31,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "31,8",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,0",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "41,1",
    "Bevölkerungsstruktur Jugendquotient  2011": "31,0",
    "Bevölkerungsstruktur Jugendquotient  2012": "30,8",
    "Bevölkerungsstruktur Altenquotient  2011": "25,8",
    "Bevölkerungsstruktur Altenquotient  2012": "25,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1102",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1139",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,5",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "607",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "228",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "317",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "735",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "178",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "176",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1435",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1434",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "51,5",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "52,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "688",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "342",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "434",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "793",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "313",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "299",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "670",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "652",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "46,3",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "47,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "273",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "198",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "163",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "248",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "234",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "206",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2845",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2878",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "51,4",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1218",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1157",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "537",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "617",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "1090",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "1104",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "9037",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "9180",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "48,3",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "48,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "4275",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "4035",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1380",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1624",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "3382",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "3521",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2967",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3011",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "55,3",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "54,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2320",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2020",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "165",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "488",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "482",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "503",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "48,5",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "48,5",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "2176",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "2333",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "46,5",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "46,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "49,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,4",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "730",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1283",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "54,9",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "53,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "4506",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "4669",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "490",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "484",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "85",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "73",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "557",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "549",
    "Bevölkerungsstruktur Staatenlose  2011": "41",
    "Bevölkerungsstruktur Staatenlose  2012": "34",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "107",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "102",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "171",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "168",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "209",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "212",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "397",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "416",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "332",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "322",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "275",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "281",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "563",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "615",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "212",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "237",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "248",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "257",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "113",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "124",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "1370",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "1373",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "138",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "186",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "51",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "109",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "30",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "47",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "66",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "101",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "459",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "613",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "406",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "662",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "106",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "153",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "80",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "88",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "163",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "196",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "490",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "773",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "3093",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "3138",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "1191",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "1220",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1819",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1830",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "83",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "88",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "8936",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "8983",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1247",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1228",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "4967",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "4989",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2722",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2766",
    "": ""
  },
  {
    "Codes": "38",
    "Stadtteil": "Sindlingen",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "8852",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "8881",
    "Bevölkerungsstruktur Frauen in %  2011": "48,8",
    "Bevölkerungsstruktur Frauen in %  2012": "48,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "4,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "4,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "3,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "5099",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "4333",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1413",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "2131",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "2340",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2417",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "26,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "27,2",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,3",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "41,4",
    "Bevölkerungsstruktur Jugendquotient  2011": "32,8",
    "Bevölkerungsstruktur Jugendquotient  2012": "32,4",
    "Bevölkerungsstruktur Altenquotient  2011": "29,2",
    "Bevölkerungsstruktur Altenquotient  2012": "28,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "576",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "568",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "349",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "124",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "137",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "358",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "90",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "86",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "694",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "702",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,3",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "365",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "170",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "197",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "397",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "132",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "135",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "339",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "336",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "45,4",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "45,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "170",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "100",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "78",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "147",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "91",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "89",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1414",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1405",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "47,3",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "48,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "641",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "620",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "301",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "313",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "472",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "472",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "4233",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "4285",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "47,0",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "46,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "2212",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "2092",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "646",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "749",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1375",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1444",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "1596",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "1585",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "55,8",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "55,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1362",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1227",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "54",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "167",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "180",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "191",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "45,1",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "45,3",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "715",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "772",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "40,1",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "41,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "47,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "48,5",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "274",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "468",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "50,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "51,1",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1651",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1687",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "353",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "363",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "32",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "31",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "281",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "312",
    "Bevölkerungsstruktur Staatenlose  2011": "23",
    "Bevölkerungsstruktur Staatenlose  2012": "24",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "85",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "84",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "45",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "46",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "48",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "46",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "198",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "201",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "100",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "108",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "181",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "178",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "162",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "169",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "32",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "45",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "98",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "95",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "69",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "74",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "622",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "586",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "51",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "69",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "42",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "77",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "10",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "10",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "53",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "81",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "287",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "417",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "127",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "200",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "32",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "46",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "36",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "43",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "153",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "180",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "206",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "322",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1436",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "1478",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "579",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "599",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "814",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "839",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "43",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "40",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "4563",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "4532",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "633",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "619",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "2441",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "2443",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "1489",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "1470",
    "": ""
  },
  {
    "Codes": "39",
    "Stadtteil": "Zeilsheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "12024",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "11927",
    "Bevölkerungsstruktur Frauen in %  2011": "50,5",
    "Bevölkerungsstruktur Frauen in %  2012": "50,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "3,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "3,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "4,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "2,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "7345",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "6249",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1812",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "2769",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "2867",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2909",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "23,8",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "24,4",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,9",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,0",
    "Bevölkerungsstruktur Jugendquotient  2011": "35,1",
    "Bevölkerungsstruktur Jugendquotient  2012": "35,3",
    "Bevölkerungsstruktur Altenquotient  2011": "32,9",
    "Bevölkerungsstruktur Altenquotient  2012": "33,0",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "854",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "834",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "524",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "217",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "240",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "524",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "90",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "93",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "959",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "981",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "47,4",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "508",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "284",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "283",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "552",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "168",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "145",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "445",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "451",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "47,9",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "48,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "216",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "156",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "89",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "162",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "140",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "133",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1757",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1685",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,6",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "846",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "747",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "363",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "374",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "548",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "564",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "5656",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "5637",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "49,0",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3239",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "3041",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "765",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "904",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1652",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1692",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2353",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2339",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "55,1",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "55,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2012",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1804",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "72",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "253",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "269",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "282",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "48,8",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "48,9",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "873",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "963",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "45,8",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "46,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "48,6",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "327",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "625",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "53,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "52,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2125",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2176",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "493",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "487",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "41",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "42",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "187",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "189",
    "Bevölkerungsstruktur Staatenlose  2011": "21",
    "Bevölkerungsstruktur Staatenlose  2012": "15",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "86",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "85",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "84",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "83",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "117",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "120",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "306",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "301",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "132",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "131",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "281",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "275",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "125",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "136",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "28",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "45",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "110",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "110",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "157",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "158",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "811",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "775",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "82",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "112",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "38",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "81",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "14",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "20",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "63",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "81",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "350",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "498",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "126",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "226",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "35",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "54",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "74",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "58",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "114",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "124",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "311",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "489",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1576",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "1594",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "589",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "577",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "938",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "956",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "49",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "61",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "6448",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "6395",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "880",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "837",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "3368",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "3373",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2200",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2185",
    "": ""
  },
  {
    "Codes": "40",
    "Stadtteil": "Unterliederbach",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "14269",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "14609",
    "Bevölkerungsstruktur Frauen in %  2011": "51,2",
    "Bevölkerungsstruktur Frauen in %  2012": "50,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "2,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "6,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "4,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "7,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "8471",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "7365",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2094",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3310",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "3704",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "3934",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "26,0",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "26,9",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,9",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "40,6",
    "Bevölkerungsstruktur Jugendquotient  2011": "32,8",
    "Bevölkerungsstruktur Jugendquotient  2012": "33,2",
    "Bevölkerungsstruktur Altenquotient  2011": "26,4",
    "Bevölkerungsstruktur Altenquotient  2012": "26,0",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "944",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "967",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,7",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "621",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "257",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "216",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "589",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "107",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "121",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1159",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1179",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,6",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "650",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "365",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "328",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "640",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "181",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "174",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "567",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "629",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "48,0",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "46,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "276",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "247",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "98",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "175",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "193",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "207",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2318",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2295",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "55,0",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "54,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1116",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1024",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "446",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "467",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "756",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "804",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "6918",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "7154",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "48,8",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3863",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "3740",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "936",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1165",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2119",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2249",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2363",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2385",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "56,9",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "56,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1945",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1732",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "70",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "274",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "348",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "379",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "49,9",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "50,0",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1320",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1426",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "46,5",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "47,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,4",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "440",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "815",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "50,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "50,1",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2830",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2957",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "428",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "476",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "77",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "84",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "350",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "401",
    "Bevölkerungsstruktur Staatenlose  2011": "19",
    "Bevölkerungsstruktur Staatenlose  2012": "16",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "99",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "101",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "163",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "154",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "125",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "151",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "391",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "414",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "219",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "224",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "220",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "241",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "169",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "175",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "87",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "108",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "222",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "229",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "171",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "197",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "760",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "773",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "115",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "153",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "53",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "112",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "35",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "52",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "96",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "135",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "326",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "472",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "149",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "298",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "41",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "46",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "76",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "80",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "125",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "137",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "277",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "467",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2181",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2290",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "928",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "931",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1180",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1282",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "73",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "77",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "7109",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "7128",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1015",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "958",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "3940",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "4006",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2154",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2164",
    "": ""
  },
  {
    "Codes": "41",
    "Stadtteil": "Sossenheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "15225",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "15252",
    "Bevölkerungsstruktur Frauen in %  2011": "50,5",
    "Bevölkerungsstruktur Frauen in %  2012": "51,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "2,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "1,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "1,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "1,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "7993",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "6561",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2906",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "4303",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "4326",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "4388",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "28,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "28,8",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "40,5",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "40,7",
    "Bevölkerungsstruktur Jugendquotient  2011": "34,5",
    "Bevölkerungsstruktur Jugendquotient  2012": "34,4",
    "Bevölkerungsstruktur Altenquotient  2011": "26,8",
    "Bevölkerungsstruktur Altenquotient  2012": "26,9",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1015",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1030",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,3",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "605",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "186",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "285",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "716",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "125",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "128",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1238",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1252",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,4",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "574",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "240",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "402",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "755",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "262",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "257",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "647",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "630",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "46,1",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "47,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "238",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "147",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "222",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "285",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "187",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "198",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2492",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2461",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,8",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1000",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "920",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "581",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "653",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "911",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "888",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "7306",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "7336",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "49,0",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3532",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "3276",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1284",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1524",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "2490",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "2536",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2527",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2543",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,9",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "56,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "2044",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1792",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "132",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "370",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "351",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "381",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "50,3",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "51,4",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1435",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1509",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "46,6",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "47,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "48,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "48,8",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "518",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "853",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "51,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "51,3",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "3324",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "3354",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "375",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "391",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "54",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "64",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "527",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "528",
    "Bevölkerungsstruktur Staatenlose  2011": "46",
    "Bevölkerungsstruktur Staatenlose  2012": "51",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "94",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "98",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "110",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "110",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "86",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "91",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "351",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "359",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "183",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "186",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "185",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "197",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "295",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "310",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "108",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "154",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "192",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "185",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "48",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "65",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "1223",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "1166",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "230",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "359",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "62",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "115",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "56",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "66",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "73",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "90",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "353",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "512",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "261",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "405",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "63",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "90",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "97",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "97",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "270",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "319",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "442",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "659",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2375",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2394",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "945",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "930",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1342",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1375",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "88",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "89",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "7427",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "7481",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1092",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1112",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "4053",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "4072",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "2282",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "2297",
    "": ""
  },
  {
    "Codes": "42",
    "Stadtteil": "Nieder-Erlenbach",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "4370",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "4588",
    "Bevölkerungsstruktur Frauen in %  2011": "51,0",
    "Bevölkerungsstruktur Frauen in %  2012": "50,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "11,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "16,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "1,1",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "5,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "3608",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "3478",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "294",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "600",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "468",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "510",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "10,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "11,1",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "43,0",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,5",
    "Bevölkerungsstruktur Jugendquotient  2011": "33,7",
    "Bevölkerungsstruktur Jugendquotient  2012": "33,6",
    "Bevölkerungsstruktur Altenquotient  2011": "30,7",
    "Bevölkerungsstruktur Altenquotient  2012": "30,2",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "260",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "297",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,2",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "48,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "213",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "186",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "34",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "94",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "13",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "17",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "390",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "381",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "45,9",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "44,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "333",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "266",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "36",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "101",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "21",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "14",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "163",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "189",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "52,8",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "51,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "130",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "138",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "15",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "31",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "18",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "20",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "489",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "538",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "49,3",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "51,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "365",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "390",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "51",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "64",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "73",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "84",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "2251",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "2338",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,6",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "50,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "1809",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "1820",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "142",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "191",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "300",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "327",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "817",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "845",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "55,8",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "55,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "758",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "678",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "16",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "119",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "43",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "48",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,9",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "50,4",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "274",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "302",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "47,4",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "45,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "49,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "48,8",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "111",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "289",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "48,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "51,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "367",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "399",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "30",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "30",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "23",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "24",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "48",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "57",
    "Bevölkerungsstruktur Staatenlose  2011": "0",
    "Bevölkerungsstruktur Staatenlose  2012": "0",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "61",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "62",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "7",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "5",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "6",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "12",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "40",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "38",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "25",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "26",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "16",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "16",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "55",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "67",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "21",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "23",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "10",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "10",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "14",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "23",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "26",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "25",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "3",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "5",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "0",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "3",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "29",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "33",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "18",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "28",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "10",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "17",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "25",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "90",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "6",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "11",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "9",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "7",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "24",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "35",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "18",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "43",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "584",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "679",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "139",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "184",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "410",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "464",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "35",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "31",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "2222",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "2255",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "276",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "283",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "1226",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "1222",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "720",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "750",
    "": ""
  },
  {
    "Codes": "43",
    "Stadtteil": "Kalbach-Riedberg",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "10279",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "12019",
    "Bevölkerungsstruktur Frauen in %  2011": "50,6",
    "Bevölkerungsstruktur Frauen in %  2012": "50,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "104,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "125,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "58,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "73,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "7159",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "7051",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1435",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "2867",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "1685",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2101",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "16,4",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "17,5",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "36,3",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "35,9",
    "Bevölkerungsstruktur Jugendquotient  2011": "38,9",
    "Bevölkerungsstruktur Jugendquotient  2012": "39,5",
    "Bevölkerungsstruktur Altenquotient  2011": "14,8",
    "Bevölkerungsstruktur Altenquotient  2012": "14,2",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "1010",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "1223",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "50,0",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "50,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "804",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "561",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "132",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "558",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "74",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "104",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1060",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1256",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "50,7",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "49,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "737",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "555",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "192",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "538",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "131",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "163",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "350",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "405",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "50,0",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "50,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "234",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "206",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "67",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "129",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "49",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "70",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1324",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1501",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "53,2",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "53,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "809",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "869",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "227",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "297",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "288",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "335",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "5546",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "6521",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "49,6",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "49,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3700",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "4032",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "779",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1155",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1067",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1334",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "989",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "1113",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "53,6",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "52,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "875",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "828",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "38",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "190",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "76",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "95",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "52,5",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "52,7",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "806",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "935",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "49,5",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "49,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "52,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "52,1",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "475",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "994",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "56,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "53,9",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1184",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1409",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "67",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "77",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "85",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "112",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "349",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "499",
    "Bevölkerungsstruktur Staatenlose  2011": "0",
    "Bevölkerungsstruktur Staatenlose  2012": "4",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "87",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "91",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "42",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "37",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "31",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "29",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "178",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "190",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "69",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "77",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "33",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "37",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "122",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "132",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "46",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "105",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "43",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "62",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "72",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "81",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "138",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "162",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "72",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "106",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "9",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "17",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "114",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "168",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "55",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "94",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "81",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "144",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "220",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "391",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "49",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "99",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "35",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "40",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "118",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "180",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "103",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "204",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2101",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2647",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "599",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "696",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1426",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1843",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "76",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "108",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "3729",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "4089",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "544",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "593",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "2339",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "2570",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "846",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "926",
    "": ""
  },
  {
    "Codes": "44",
    "Stadtteil": "Harheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "4258",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "4304",
    "Bevölkerungsstruktur Frauen in %  2011": "51,2",
    "Bevölkerungsstruktur Frauen in %  2012": "51,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "12,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "14,3",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "14,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "12,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "3547",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "3367",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "243",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "481",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "468",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "456",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "11,0",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "10,6",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "42,1",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,4",
    "Bevölkerungsstruktur Jugendquotient  2011": "33,7",
    "Bevölkerungsstruktur Jugendquotient  2012": "33,5",
    "Bevölkerungsstruktur Altenquotient  2011": "29,6",
    "Bevölkerungsstruktur Altenquotient  2012": "30,8",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "293",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "280",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "46,8",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "46,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "252",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "193",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "30",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "83",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "11",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "4",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "360",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "367",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,2",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "48,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "287",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "249",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "42",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "92",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "31",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "26",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "154",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "151",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "51,9",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "51,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "118",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "104",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "9",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "23",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "27",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "24",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "492",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "531",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,6",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "365",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "377",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "45",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "58",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "82",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "96",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "2187",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "2168",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,9",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "51,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "1785",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "1749",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "112",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "150",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "290",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "269",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "772",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "807",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "53,5",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "53,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "740",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "695",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "5",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "75",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "27",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "37",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "49,6",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "48,7",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "289",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "303",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "46,7",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "47,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "51,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "54,1",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "97",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "236",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "55,7",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "56,8",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "361",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "365",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "32",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "25",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "29",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "26",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "46",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "40",
    "Bevölkerungsstruktur Staatenlose  2011": "0",
    "Bevölkerungsstruktur Staatenlose  2012": "0",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "49",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "51",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "3",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "3",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "5",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "5",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "33",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "30",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "10",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "9",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "23",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "17",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "39",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "44",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "13",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "10",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "8",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "6",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "15",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "19",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "39",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "35",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "8",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "12",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "1",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "3",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "7",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "9",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "18",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "33",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "25",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "30",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "27",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "74",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "8",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "16",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "8",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "8",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "13",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "25",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "14",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "27",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "590",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "584",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "173",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "204",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "396",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "354",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "21",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "26",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "2331",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "2342",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "264",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "263",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "1334",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "1320",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "733",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "759",
    "": ""
  },
  {
    "Codes": "45",
    "Stadtteil": "Nieder-Eschbach",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "11247",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "11351",
    "Bevölkerungsstruktur Frauen in %  2011": "52,0",
    "Bevölkerungsstruktur Frauen in %  2012": "52,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "-1,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "-1,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "-0,2",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "1,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "7069",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "5889",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "2182",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "3337",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "1996",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2125",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "17,7",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "18,7",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "42,4",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "42,5",
    "Bevölkerungsstruktur Jugendquotient  2011": "32,0",
    "Bevölkerungsstruktur Jugendquotient  2012": "32,2",
    "Bevölkerungsstruktur Altenquotient  2011": "31,1",
    "Bevölkerungsstruktur Altenquotient  2012": "31,1",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "670",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "700",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "48,5",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "50,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "491",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "195",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "125",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "438",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "54",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "67",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "860",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "846",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "49,1",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "48,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "523",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "268",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "227",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "478",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "110",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "100",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "451",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "452",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "47,2",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "47,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "255",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "161",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "123",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "205",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "73",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "86",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1709",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1716",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,2",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "52,4",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "922",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "868",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "433",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "448",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "354",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "400",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "5414",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "5478",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "51,0",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "51,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "3085",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "2933",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "1128",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1280",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1201",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1265",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "2143",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "2159",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,9",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "58,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "1793",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "1464",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "146",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "488",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "204",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "207",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "53,4",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "52,7",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "716",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "750",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "51,5",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "52,1",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "595",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1044",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "50,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "53,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1352",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1398",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "169",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "181",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "61",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "62",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "398",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "465",
    "Bevölkerungsstruktur Staatenlose  2011": "16",
    "Bevölkerungsstruktur Staatenlose  2012": "19",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "91",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "92",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "31",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "38",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "99",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "95",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "151",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "156",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "98",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "106",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "92",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "91",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "149",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "148",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "43",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "69",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "57",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "70",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "22",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "29",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "319",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "289",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "191",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "285",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "77",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "120",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "66",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "77",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "47",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "62",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "151",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "211",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "329",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "525",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "75",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "117",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "43",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "36",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "217",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "265",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "119",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "223",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1610",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "1692",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "633",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "674",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "896",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "933",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "81",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "85",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "5843",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "5876",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "810",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "787",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "3114",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "3139",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "1919",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "1950",
    "": ""
  },
  {
    "Codes": "46",
    "Stadtteil": "Bergen-Enkheim",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "17512",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "17563",
    "Bevölkerungsstruktur Frauen in %  2011": "51,9",
    "Bevölkerungsstruktur Frauen in %  2012": "51,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "7,4",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "6,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "3,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "3,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "13003",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "11797",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1801",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "2924",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "2708",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "2842",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "15,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "16,2",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "44,3",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "44,3",
    "Bevölkerungsstruktur Jugendquotient  2011": "27,5",
    "Bevölkerungsstruktur Jugendquotient  2012": "28,0",
    "Bevölkerungsstruktur Altenquotient  2011": "33,4",
    "Bevölkerungsstruktur Altenquotient  2012": "33,7",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "892",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "921",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "50,1",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "681",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "434",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "150",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "418",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "61",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "69",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "1223",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "1222",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "51,7",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "52,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "885",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "609",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "253",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "527",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "85",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "86",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "598",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "590",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "47,7",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "48,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "428",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "356",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "89",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "155",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "81",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "79",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "2189",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "2229",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "50,4",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "50,7",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "1390",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "1367",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "315",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "330",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "484",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "532",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "8974",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "8942",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "51,4",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "51,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "6366",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "6135",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "903",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "1044",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1705",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1763",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "3636",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "3659",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "55,1",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "55,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "3253",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "2896",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "91",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "450",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "292",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "313",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,0",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "50,9",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "1153",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "1296",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "52,0",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "51,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "50,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "51,9",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "529",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "1058",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "51,2",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "52,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "2212",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "2350",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "129",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "124",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "97",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "100",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "260",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "254",
    "Bevölkerungsstruktur Staatenlose  2011": "10",
    "Bevölkerungsstruktur Staatenlose  2012": "14",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "96",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "97",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "99",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "98",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "100",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "99",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "338",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "379",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "274",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "277",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "55",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "58",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "188",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "243",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "49",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "46",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "135",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "129",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "87",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "90",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "416",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "403",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "44",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "66",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "14",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "34",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "138",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "133",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "107",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "130",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "95",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "146",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "176",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "386",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "50",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "75",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "67",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "61",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "96",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "113",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "217",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "365",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "2249",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "2308",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "732",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "810",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "1428",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "1415",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "89",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "83",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "9761",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "9758",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "1137",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "1132",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "5297",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "5274",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "3327",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "3352",
    "": ""
  },
  {
    "Codes": "47",
    "Stadtteil": "Frankfurter Berg",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "7551",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "7627",
    "Bevölkerungsstruktur Frauen in %  2011": "51,0",
    "Bevölkerungsstruktur Frauen in %  2012": "50,9",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "48,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "38,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "14,6",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "13,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "4219",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "3537",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "1552",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "2274",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "1780",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "1816",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "23,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "23,8",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "38,6",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "39,0",
    "Bevölkerungsstruktur Jugendquotient  2011": "37,8",
    "Bevölkerungsstruktur Jugendquotient  2012": "38,1",
    "Bevölkerungsstruktur Altenquotient  2011": "18,9",
    "Bevölkerungsstruktur Altenquotient  2012": "19,9",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "581",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "563",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,2",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "404",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "181",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "112",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "316",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "65",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "66",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "703",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "715",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "47,7",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "47,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "434",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "234",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "173",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "396",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "96",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "85",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "358",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "362",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "53,6",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "53,0",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "162",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "127",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "103",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "149",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "93",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "86",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "1087",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "1070",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,5",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "51,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "459",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "442",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "304",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "306",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "324",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "322",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "3912",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "3958",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "50,0",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "50,1",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "2032",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "1930",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "803",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "917",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "1077",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "1111",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "910",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "959",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "56,3",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "55,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "728",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "623",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "57",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "190",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "125",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "146",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "51,8",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "51,7",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "558",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "591",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "47,7",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "47,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "48,8",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,8",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "344",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "557",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "48,0",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "51,5",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "1207",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "1236",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "156",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "157",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "42",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "42",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "363",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "370",
    "Bevölkerungsstruktur Staatenlose  2011": "12",
    "Bevölkerungsstruktur Staatenlose  2012": "11",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "85",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "93",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "67",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "62",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "50",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "47",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "174",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "168",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "104",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "108",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "51",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "49",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "105",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "133",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "48",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "56",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "74",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "65",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "26",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "28",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "289",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "288",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "116",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "147",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "48",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "75",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "84",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "103",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "38",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "49",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "88",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "107",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "151",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "237",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "36",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "55",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "67",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "54",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "103",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "120",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "154",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "241",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "1091",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "1122",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "388",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "375",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "668",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "707",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "35",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "40",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "3467",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "3503",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "542",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "542",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "2135",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "2132",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "790",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "829",
    "": ""
  },
  {
    "Codes": "#Frankfurt",
    "Stadtteil": "Frankfurt am Main",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "667075",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "678691",
    "Bevölkerungsstruktur Frauen in %  2011": "50,9",
    "Bevölkerungsstruktur Frauen in %  2012": "50,8",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "7,7",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "9,0",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "5,5",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "6,6",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "403663",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "357050",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "92901",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "144706",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "170511",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "176935",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "25,6",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "26,1",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "41,3",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "41,3",
    "Bevölkerungsstruktur Jugendquotient  2011": "26,6",
    "Bevölkerungsstruktur Jugendquotient  2012": "26,6",
    "Bevölkerungsstruktur Altenquotient  2011": "24,9",
    "Bevölkerungsstruktur Altenquotient  2012": "24,6",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "40328",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "41121",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "49,2",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "49,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "26795",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "13179",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "8842",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "22974",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "4691",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "4968",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "44822",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "45703",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "48,8",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "48,8",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "25278",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "14913",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "11938",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "23606",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "7606",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "7184",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "20736",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "21235",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "48,1",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "48,5",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "10228",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "7825",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "4894",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "7751",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "5614",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "5659",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "107411",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "109209",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "52,3",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "52,2",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "55469",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "53909",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "17931",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "20179",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "34011",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "35121",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "344250",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "350862",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "48,9",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "48,9",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "196525",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "188497",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "44819",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "55110",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "102906",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "107255",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "109528",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "110561",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "57,6",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "57,3",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "89368",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "78727",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "4477",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "15086",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "15683",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "16748",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "49,4",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "49,3",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "64884",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "69677",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "46,9",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "46,6",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "49,4",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "49,9",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "22524",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "40981",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "50,5",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "52,2",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "127254",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "131841",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "12897",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "13109",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "6304",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "6592",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "23155",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "24511",
    "Bevölkerungsstruktur Staatenlose  2011": "901",
    "Bevölkerungsstruktur Staatenlose  2012": "882",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "170",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "173",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "4917",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "4912",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "5982",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "6149",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "13448",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "13711",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "11539",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "11596",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "5707",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "5711",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "10975",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "11942",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "4765",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "5937",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "8973",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "8982",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "4769",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "5329",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "28854",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "28090",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "3485",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "4983",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "2.040",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "4209",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "4141",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "5023",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "3124",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "4326",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "9905",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "13243",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "8685",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "15042",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "2723",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "4082",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "3266",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "3139",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "6156",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "6989",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "10941",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "17680",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "137974",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "142700",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "54662",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "56715",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "79094",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "81562",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "4218",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "4423",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "304486",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "305665",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "37527",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "37403",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "168432",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "169085",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "98527",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "99177",
    "": ""
  },
  {
    "Codes": "",
    "Stadtteil": "",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011": "",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012": "",
    "Bevölkerungsstruktur Frauen in %  2011": "",
    "Bevölkerungsstruktur Frauen in %  2012": "",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011": "",
    "Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012": "",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011": "",
    "Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012": "",
    "Bevölkerungsstruktur Durchschnittsalter  2011": "",
    "Bevölkerungsstruktur Durchschnittsalter  2012": "",
    "Bevölkerungsstruktur Jugendquotient  2011": "",
    "Bevölkerungsstruktur Jugendquotient  2012": "",
    "Bevölkerungsstruktur Altenquotient  2011": "",
    "Bevölkerungsstruktur Altenquotient  2012": "",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2011": "",
    "Bevölkerungsstruktur Kinder bis 5 Jahre  2012": "",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011": "",
    "Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012": "",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011": "",
    "Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012": "",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011": "",
    "Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012": "",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011": "",
    "Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012": "",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011": "",
    "Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012": "",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011": "",
    "Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012": "",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011": "",
    "Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012": "",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011": "",
    "Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012": "",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011": "",
    "Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012": "",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011": "",
    "Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012": "",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011": "",
    "Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012": "",
    "Bevölkerungsstruktur Ausländerinnen in %  2011": "",
    "Bevölkerungsstruktur Ausländerinnen in %  2012": "",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011": "",
    "Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012": "",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2011": "",
    "Bevölkerungsstruktur EU-Ausländerinnen in %  2012": "",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011": "",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011": "",
    "Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012": "",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011": "",
    "Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011": "",
    "Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012": "",
    "Bevölkerungsstruktur Staatenlose  2011": "",
    "Bevölkerungsstruktur Staatenlose  2012": "",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011": "",
    "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012": "",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2011": "",
    "Bevölkerungsstruktur Bosnierinnen und Bosnier  2012": "",
    "Bevölkerungsstruktur Griechinnen und Griechen  2011": "",
    "Bevölkerungsstruktur Griechinnen und Griechen  2012": "",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2011": "",
    "Bevölkerungsstruktur Italienerinnen und Italiener  2012": "",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2011": "",
    "Bevölkerungsstruktur Kroatinnen und Kroaten  2012": "",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011": "",
    "Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012": "",
    "Bevölkerungsstruktur Polinnen und Polen  2011": "",
    "Bevölkerungsstruktur Polinnen und Polen  2012": "",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2011": "",
    "Bevölkerungsstruktur Rumäninnen und Rumänen  2012": "",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2011": "",
    "Bevölkerungsstruktur Serbierinnen und Serbier  2012": "",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2011": "",
    "Bevölkerungsstruktur Spanierinnen und Spanier  2012": "",
    "Bevölkerungsstruktur Türkinnen und Türken  2011": "",
    "Bevölkerungsstruktur Türkinnen und Türken  2012": "",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011": "",
    "Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012": "",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011": "",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012": "",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011": "",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012": "",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011": "",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012": "",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011": "",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012": "",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011": "",
    "Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012": "",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011": "",
    "Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012": "",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011": "",
    "Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012": "",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011": "",
    "Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012": "",
    "": ""
  }
]


// WEBPACK FOOTER //
// ./src/data/bevolkerungsstruktur.js